/* cache-bust: 2026-04-19-v2.4.2-polish */
const DEFAULT_KAIDO_REVIEWS_CONFIG = {
  endpoints: {
    getReviews:
      "https://api.kaidomotors.com/functions/v1/get_reviews",
    presignUpload:
      "https://api.kaidomotors.com/functions/v1/presign_review_upload",
    submitReview:
      "https://api.kaidomotors.com/functions/v1/submit_review",
    getReviewTokens:
      "https://api.kaidomotors.com/functions/v1/get_review_tokens",
  },
  media: {
    maxImages: 2,
    maxVideos: 1,
  },
  security: {
    reviewWorkerUrl: "",
    signerEndpoint: "",
    payloadVersion: 1,
  },
};

const KAIDO_REVIEWS_CONFIG = (() => {
  if (typeof window === "undefined") return DEFAULT_KAIDO_REVIEWS_CONFIG;
  const globalConfig = window.KAIDO_REVIEWS_CONFIG || {};
  return {
    ...DEFAULT_KAIDO_REVIEWS_CONFIG,
    ...globalConfig,
    endpoints: {
      ...DEFAULT_KAIDO_REVIEWS_CONFIG.endpoints,
      ...(globalConfig.endpoints || {}),
    },
    media: {
      ...DEFAULT_KAIDO_REVIEWS_CONFIG.media,
      ...(globalConfig.media || {}),
    },
    security: {
      ...DEFAULT_KAIDO_REVIEWS_CONFIG.security,
      ...(globalConfig.security || {}),
    },
  };
})();

const STAR_PATH =
  '<path fill="currentColor" d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>';

const REVIEW_IMAGE_OUTPUT_SOFT_BYTES = 750000;
const REVIEW_IMAGE_OUTPUT_HARD_BYTES = 1048576;
const REVIEW_IMAGE_QUALITY_FLOOR = 0.6;
const REVIEW_IMAGE_DIMENSION_STEPS = [1600, 1280, 1024, 960];
const REVIEW_IMAGE_COMPRESSION_TIMEOUT_MS = 20000;

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-kaido-reviews]")
    .forEach((section) => initKaidoReviews(section));
});

function initKaidoReviews(sectionElement) {
  if (!sectionElement || sectionElement._kaidoReviews) return;
  const app = new KaidoReviewsApp(sectionElement);
  sectionElement._kaidoReviews = app;
  app.init();
}

class KaidoReviewsApp {
  constructor(sectionEl) {
    this.sectionEl = sectionEl;
    const rawProductId = sectionEl.dataset.productId;
    // Treat "0" or blank as no product filter (landing page shows all reviews)
    this.productId = rawProductId && rawProductId !== "0" ? rawProductId : "";
    // Shopify Liquid has no request.params — read review_token from URL instead
    const urlToken = new URLSearchParams(window.location.search).get("review_token") || "";
    this.reviewToken = sectionEl.dataset.reviewToken || urlToken;
    const isCustomerAttr = (sectionEl.dataset.isCustomer || "")
      .trim()
      .toLowerCase();
    this.isCustomer = isCustomerAttr === "true" || isCustomerAttr === "1";
    if (!this.isCustomer && sectionEl.dataset.customerId) {
      this.isCustomer = true;
    }
    this.customerId = sectionEl.dataset.customerId || "";
    this.customerEmail = sectionEl.dataset.customerEmail || "";
    this.customerName = sectionEl.dataset.customerName || "Anonymous";
    this.loginUrl = sectionEl.dataset.loginUrl || "/account/login";

    this.desktopWrapper = sectionEl.querySelector(".kaido-reviews-desktop");
    this.mobileWrapper = sectionEl.querySelector(".kaido-reviews-mobile");
    this.reviewsGridDesktop = sectionEl.querySelector("#reviewsGrid-desktop");
    this.reviewsGridMobile = sectionEl.querySelector(
      "#kaido-reviews-mobile-list"
    );
    this.loadingNodes = sectionEl.querySelectorAll("[data-review-loading]");
    this.emptyNodes = sectionEl.querySelectorAll("[data-review-empty]");
    this.emptyNodesMobile = sectionEl.querySelectorAll(
      "[data-review-empty-mobile]"
    );
    this.summaryNodes = {
      avgRating: sectionEl.querySelector('[data-review-stat="avg-rating"]'),
      totalText: sectionEl.querySelector('[data-review-stat="total-count"]'),
      totalTextMobile: sectionEl.querySelector(
        '[data-review-stat="total-count-mobile"]'
      ),
      avgRatingMobile: sectionEl.querySelector(
        '[data-review-stat="avg-rating-mobile"]'
      ),
      starSummaryDesktop: sectionEl.querySelector("#summaryStarRating-desktop"),
      starSummaryMobile: sectionEl.querySelector("#summaryStarRating-mobile"),
    };

    this.filters = {
      desktop: {
        sort: sectionEl.querySelector("#sortBy-desktop"),
        rating: sectionEl.querySelector("#filterRating-desktop"),
        media: sectionEl.querySelector("#filterMedia-desktop"),
      },
      mobile: {
        rating: sectionEl.querySelector("#filterRating-mobile"),
        media: sectionEl.querySelector("#filterMedia-mobile"),
      },
    };

    this.loginModal = document.getElementById("kaido-reviews-login-modal");
    this.loginBannerButton = sectionEl.querySelector(
      "[data-kaido-login-trigger]"
    );
    this.writeButtons = Array.from(
      sectionEl.querySelectorAll("[data-kaido-write-review]")
    );
    if (!this.writeButtons.length) {
      this.writeButtons = Array.from(
        sectionEl.querySelectorAll(
          "#writeReviewBtn-desktop, #write-review-btn-mobile"
        )
      );
    }
    this.reviewModals = sectionEl.querySelectorAll("[data-review-modal]");
    this.reviewDetailModals = sectionEl.querySelectorAll(
      "[data-review-detail-modal]"
    );
    this.forms = sectionEl.querySelectorAll("[data-kaido-review-form]");
    this.productSelects = sectionEl.querySelectorAll("[data-product-select]");
    this.productEmptyMessages = sectionEl.querySelectorAll(
      "[data-no-orders-message]"
    );

    this.currentFilters = {
      page: 1,
      rating: "all",
      media: "any",
      sort: "recent",
    };
    this.templates = {
      desktop: document.getElementById("kaido-review-card-template"),
      mobile: document.getElementById("kaido-review-card-mobile-template"),
    };

    this.loadMoreButtons = Array.from(
      sectionEl.querySelectorAll("[data-load-more]")
    );
    this.pagination = {
      pageSize: 20,
      mediaPage: 1,
      textPage: 1,
      textOffset: 0,
      mediaExhausted: false,
      textExhausted: false,
    };
    this.renderedReviewKeys = new Set();
    this.lastFetchStats = null;

    this.reviewTokens = [];
    this.entryRewards = { text: 100, photo: 250, video: 500 };
    this.accumulatedFiles = new Map(); // Store accumulated files per form
  }

  init() {
    this.attachFilterHandlers();
    this.attachWriteReviewHandlers();
    this.attachLoginHandlers();
    this.attachFormHandlers();
    this.attachDetailModalHandlers();
    this.attachLoadMoreHandlers();
    this.initProductSelectionFlow();
    this.initReviewDrawer();
    this.fetchAndRenderReviews();

    // Auto-open review modal when arriving from email deep link (?review_token=xxx)
    // UUID validation prevents garbage query params from triggering the modal
    const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (this.reviewToken && uuidPattern.test(this.reviewToken)) {
      // Bug 2 fix: check token status before opening modal.
      // get_review_tokens only returns minted (non-consumed) tokens, so if the
      // token is absent from the response it has already been used.
      this._openModalIfTokenActive();
    }
  }

  async _openModalIfTokenActive() {
    // If we can verify the token is still active, open the modal.
    // Fall back to opening when we cannot check (e.g. logged-out visitor).
    let shouldOpen = true;

    const endpoint = (KAIDO_REVIEWS_CONFIG.endpoints?.getReviewTokens || "").trim();
    if (endpoint && (this.customerEmail || this.customerId)) {
      try {
        const params = new URLSearchParams();
        if (this.customerEmail) params.set("email", this.customerEmail);
        if (this.customerId) params.set("customer_id", this.customerId);
        const resp = await fetch(`${endpoint}?${params.toString()}`, {
          headers: { "Content-Type": "application/json" },
        });
        if (resp.ok) {
          const data = await resp.json();
          const activeTokens = Array.isArray(data.tokens) ? data.tokens : [];
          const isActive = activeTokens.some((t) => t.token === this.reviewToken);
          if (!isActive) {
            // Token not in the active list — it has been consumed or expired.
            shouldOpen = false;
          }
        }
      } catch (_err) {
        // Network error: default to opening (let backend reject if needed).
      }
    }

    if (!shouldOpen) return;

    // 1500ms delay allows page and modals to fully render
    const tryOpenModal = (attempts = 0) => {
      const isDesktop = window.innerWidth > 768;
      const modalSelector = isDesktop
        ? '[data-review-modal="desktop"]'
        : '[data-review-modal="mobile"]';
      const modal =
        this.sectionEl.querySelector(modalSelector) ||
        document.querySelector(modalSelector);
      if (modal) {
        this.sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });
        modal.classList.add("is-open");
      } else if (attempts < 5) {
        setTimeout(() => tryOpenModal(attempts + 1), 500);
      }
    };
    setTimeout(() => tryOpenModal(), 1500);
  }

  attachFilterHandlers() {
    const handleChange = (e) => {
      // 1. Identify which dropdown triggered the change and its new value
      const targetId = e.target.id || "";
      const newValue = e.target.value;

      // 2. Update the corresponding state and sync the dropdowns
      if (targetId.includes("sortBy")) {
        this.currentFilters.sort = newValue;
        // If you ever add mobile sort, sync it here
        if (this.filters.desktop.sort) this.filters.desktop.sort.value = newValue;
      } else if (targetId.includes("filterRating")) {
        this.currentFilters.rating = newValue;
        // Sync both so desktop and mobile views match
        if (this.filters.desktop.rating) this.filters.desktop.rating.value = newValue;
        if (this.filters.mobile.rating) this.filters.mobile.rating.value = newValue;
      } else if (targetId.includes("filterMedia")) {
        this.currentFilters.media = newValue;
        // Sync both so desktop and mobile views match
        if (this.filters.desktop.media) this.filters.desktop.media.value = newValue;
        if (this.filters.mobile.media) this.filters.mobile.media.value = newValue;
      }

      // 3. Reset to page 1 and fetch new results
      this.currentFilters.page = 1;
      this.fetchAndRenderReviews();
    };

    // Attach listeners passing the event (e)
    Object.values(this.filters.desktop).forEach((select) => {
      if (select) select.addEventListener("change", handleChange);
    });
    if (this.filters.mobile.rating)
      this.filters.mobile.rating.addEventListener("change", handleChange);
    if (this.filters.mobile.media)
      this.filters.mobile.media.addEventListener("change", handleChange);
  }

  attachWriteReviewHandlers() {
    this.writeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) {
          return;
        }
        if (!this.canSubmitReview()) {
          this.openLoginModal();
          return;
        }
        const targetType =
          button.dataset.kaidoWriteReview ||
          (button.id === "writeReviewBtn-desktop" ? "desktop" : "mobile");
        const selector =
          targetType === "mobile"
            ? '[data-review-modal="mobile"]'
            : '[data-review-modal="desktop"]';
        const targetModal =
          this.sectionEl.querySelector(selector) ||
          document.querySelector(selector);
        if (targetModal) {
          targetModal.classList.add("is-open");

          // Reset file preview and accumulated files when opening modal
          const form = targetModal.querySelector("[data-kaido-review-form]");
          if (form) {
            const formType = form.getAttribute("data-review-form-type");
            const formId = form.id || formType;
            const filePreview = form.querySelector(
              `[data-file-preview-${formType}]`
            );
            if (filePreview) {
              filePreview.hidden = true;
            }
            // Clear accumulated files
            this.accumulatedFiles.delete(formId);
          }
        }
      });
    });

    this.reviewModals.forEach((modal) => {
      modal.querySelectorAll("[data-close-review-modal]").forEach((btn) => {
        btn.addEventListener("click", () => modal.classList.remove("is-open"));
      });
      modal.addEventListener("click", (evt) => {
        if (evt.target === modal) modal.classList.remove("is-open");
      });
      modal.querySelectorAll("[data-next-page]").forEach((btn) => {
        const requirementSelector = btn.dataset.requireValue;
        const requiredInput = requirementSelector
          ? modal.querySelector(requirementSelector)
          : null;
        if (requiredInput) {
          const updateState = () => {
            const hasValue = this.inputRequirementHasValue(requiredInput);
            btn.disabled = !hasValue;
            btn.classList.toggle("is-disabled", !hasValue);
            btn.setAttribute("aria-disabled", String(!hasValue));
          };
          this.registerRequirementWatcher(requiredInput, updateState);
          updateState();
        }
        btn.addEventListener("click", () => {
          if (btn.disabled) return;
          const requirement = btn.dataset.requireValue;
          if (requirement) {
            const requiredInput = modal.querySelector(requirement);
            if (
              requiredInput &&
              !this.inputRequirementHasValue(requiredInput)
            ) {
              requiredInput.classList.add("is-invalid");
              if (typeof requiredInput.focus === "function")
                requiredInput.focus();
              setTimeout(
                () => requiredInput.classList.remove("is-invalid"),
                1800
              );
              return;
            }
          }
          this.showModalPage(modal, btn.dataset.nextPage);
        });
      });
      modal.querySelectorAll("[data-prev-page]").forEach((btn) => {
        btn.addEventListener("click", () =>
          this.showModalPage(modal, btn.dataset.prevPage)
        );
      });
    });
  }

  attachLoginHandlers() {
    if (this.loginBannerButton) {
      this.loginBannerButton.addEventListener("click", () =>
        this.openLoginModal()
      );
    }
    if (this.loginModal) {
      this.loginModal
        .querySelectorAll("[data-close-login-modal]")
        .forEach((btn) => {
          btn.addEventListener("click", () =>
            this.loginModal.classList.remove("is-open")
          );
        });
      this.loginModal.addEventListener("click", (evt) => {
        if (evt.target === this.loginModal)
          this.loginModal.classList.remove("is-open");
      });
    }
  }

  attachLoadMoreHandlers() {
    this.loadMoreButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.disabled) return;
        this.fetchAndRenderReviews({ append: true });
      });
    });
  }

  attachFormHandlers() {
    // console.log removed
    this.forms.forEach((form) => {
      // console.log removed
      const productSelect = form.querySelector("[data-product-select]");
      if (productSelect) {
        productSelect.addEventListener("change", () => {
          this.handleProductSelectChange(productSelect);
          const autoNext = Number(productSelect.dataset.autoNextStep || 0);
          if (productSelect.value && autoNext) {
            this.autoAdvanceStep(form, autoNext);
          }
        });
      }

      const starPicker = form.querySelector("[data-star-picker]");
      if (starPicker) {
        starPicker.addEventListener("click", (evt) => {
          // Try to find the target by checking the event target and its parent
          let target = evt.target;

          // If clicked on path inside SVG, get the SVG parent
          if (target.tagName === "path") {
            target = target.closest("svg[data-value]");
          }

          // If still no data-value, try closest
          if (!target || !target.dataset.value) {
            target = evt.target.closest("[data-value]");
          }

          if (!target || !target.dataset.value) return;

          const rating = Number(target.dataset.value);
          this.updateStarPicker(starPicker, rating);

          const nextStep = Number(starPicker.dataset.autoNextStep || 0);
          if (nextStep) {
            // Small delay to ensure rating is set before advancing
            setTimeout(() => {
              this.autoAdvanceStep(form, nextStep);
            }, 100);
          }
        });
      }

      // Auto-detect review type based on unified file upload with validation
      const unifiedInput = form.querySelector('[data-media-input="unified"]');
      const reviewTypeSelect = form.querySelector("[data-review-type-select]");

      if (unifiedInput && reviewTypeSelect) {
        unifiedInput.addEventListener("change", async () => {
          const formType = form.getAttribute("data-review-form-type");
          const formId = form.id || formType;
          const filePreview = form.querySelector(
            `[data-file-preview-${formType}]`
          );
          const fileListEl = filePreview
            ? filePreview.querySelector("[data-file-list]")
            : null;
          const fileError = form.querySelector(`[data-file-error-${formType}]`);
          const errorMessageEl = fileError
            ? fileError.querySelector("[data-error-message]")
            : null;

          // console.log [DEBUG] (removed) File input changed");
          // console.log [DEBUG] (removed) formType:", formType);
          // console.log [DEBUG] (removed) formId:", formId);
          // console.log [DEBUG] (removed) filePreview element:", filePreview);
          // console.log [DEBUG] (removed) fileListEl element:", fileListEl);
          // console.log [DEBUG] (removed) files selected:", unifiedInput.files.length);

          // Hide error initially
          if (fileError) {
            fileError.hidden = true;
          }

          if (!unifiedInput.files || unifiedInput.files.length === 0) {
            // No new files selected
            const existingFiles = this.accumulatedFiles.get(formId) || [];
            if (existingFiles.length === 0) {
              reviewTypeSelect.value = "text";
              if (filePreview) {
                filePreview.hidden = true;
              }
            }
            return;
          }

          // Get existing accumulated files for this form
          const existingFiles = this.accumulatedFiles.get(formId) || [];
          const newFiles = Array.from(unifiedInput.files);

          // Merge existing and new files (avoid duplicates by name)
          const allFilesMap = new Map();
          existingFiles.forEach((file) => allFilesMap.set(file.name, file));
          newFiles.forEach((file) => allFilesMap.set(file.name, file));
          const mergedFiles = Array.from(allFilesMap.values());

          // Validate merged files
          const validation = await this.validateFileUpload(mergedFiles);

          if (!validation.valid) {
            // Show error
            if (fileError && errorMessageEl) {
              errorMessageEl.textContent = validation.error;
              fileError.hidden = false;

              // Auto-hide error after 5 seconds
              setTimeout(() => {
                if (fileError) {
                  fileError.hidden = true;
                }
              }, 5000);
            }
            // Don't update accumulated files on error
            try {
              unifiedInput.value = "";
            } catch (err) {
              // Some browsers don't allow clearing file input
            }
            return;
          }

          // Validation passed - store merged files
          this.accumulatedFiles.set(formId, mergedFiles);

          // Update input with merged files using DataTransfer
          try {
            const dt = new DataTransfer();
            mergedFiles.forEach((file) => dt.items.add(file));
            unifiedInput.files = dt.files;
          } catch (err) {
            // Some browsers don't support DataTransfer
            console.warn("Could not update file input with accumulated files");
          }

          // Determine review type
          const hasVideo = mergedFiles.some((file) =>
            file.type.startsWith("video/")
          );
          const hasImage = mergedFiles.some((file) =>
            file.type.startsWith("image/")
          );

          if (hasVideo) {
            reviewTypeSelect.value = "video";
          } else if (hasImage) {
            reviewTypeSelect.value = "photos";
          } else {
            reviewTypeSelect.value = "text";
          }

          // Update file preview with individual file items
          // console.log [DEBUG] (removed) About to render file list");
          // console.log [DEBUG] (removed) filePreview exists?", !!filePreview);
          // console.log [DEBUG] (removed) fileListEl exists?", !!fileListEl);
          // console.log [DEBUG] (removed) mergedFiles count:", mergedFiles.length);

          if (filePreview && fileListEl) {
            // console.log [DEBUG] (removed) Calling renderFileList");
            this.renderFileList(
              fileListEl,
              mergedFiles,
              formId,
              unifiedInput,
              reviewTypeSelect
            );
            filePreview.hidden = false;
          }
        });
      }

      // Setup character counters for text inputs
      this.setupCharacterCounters(form);

      form.addEventListener("submit", (evt) => {
        evt.preventDefault();
        this.submitForm(form);
      });
    });
  }

  setupCharacterCounters(form) {
    const limits = {
      title: 75,
      body: 5000,
      nickname: 30
    };

    const minimums = {
      body: 20
    };

    Object.keys(limits).forEach(fieldName => {
      const input = form.querySelector(`[name="${fieldName}"]`);
      if (!input) return;

      const limit = limits[fieldName];
      const formGroup = input.closest('.form-group, .kaido-form-group');
      if (!formGroup) return;

      // Create counter element
      const counter = document.createElement('div');
      counter.className = 'kaido-char-counter';
      counter.textContent = `0 / ${limit}`;

      // Insert after the input/textarea
      input.parentNode.insertBefore(counter, input.nextSibling);

      // Update counter on input
      const updateCounter = () => {
        const length = input.value.length;
        const minimum = minimums[fieldName] || 0;

        if (length > limit) {
          counter.classList.add('over-limit');
          counter.classList.remove('under-limit');
          input.value = input.value.substring(0, limit);
          counter.textContent = `${limit} / ${limit}`;
        } else if (minimum > 0 && length > 0 && length < minimum) {
          counter.classList.add('under-limit');
          counter.classList.remove('over-limit');
          counter.textContent = `${length} / ${limit} (min ${minimum})`;
        } else {
          counter.classList.remove('over-limit', 'under-limit');
          if (minimum > 0) {
            counter.textContent = `${length} / ${limit} (min ${minimum})`;
          } else {
            counter.textContent = `${length} / ${limit}`;
          }
        }
      };

      input.addEventListener('input', updateCounter);
      input.addEventListener('change', updateCounter);
    });
  }

  initProductSelectionFlow() {
    if (this.reviewToken) {
      this.setWriteButtonsDisabled(false);
      // Bug 1 fix: When arriving via deep link the product select is never
      // rebuilt by JS, so the Liquid-rendered fallback option (value="0",
      // empty text) remains visible. Remove any option whose value is "0" or
      // whose data-product-id is "0" — these are Liquid nil-object artifacts.
      this.productSelects.forEach((select) => {
        Array.from(select.options).forEach((opt) => {
          if (opt.value === "0" || opt.dataset.productId === "0") {
            select.removeChild(opt);
          }
        });
      });
      return;
    }
    if (!this.productSelects.length) {
      this.setWriteButtonsDisabled(false);
      return;
    }
    if (!this.isCustomer || (!this.customerEmail && !this.customerId)) {
      this.handleNoEligibleOrders();
      return;
    }
    this.loadReviewTokens();
  }

  async loadReviewTokens() {
    try {
      // v2.1 (2026-04-18): worker path falls back to legacy endpoint on ANY
      // worker/signer error so a broken App Proxy doesn't silently kill the
      // drawer. Legacy endpoint was updated to include invite_sent tokens on
      // the same date (edge function v50).
      let result;
      if (this.canUseSecureTokenFlow()) {
        try {
          result = await this.fetchTokensViaWorker();
        } catch (workerErr) {
          console.warn("[Kaido Reviews] Worker failed, falling back to legacy:", workerErr);
          result = await this.fetchTokensViaLegacy();
        }
      } else {
        result = await this.fetchTokensViaLegacy();
      }
      // Both paths now return { tokens, entryRewards }
      if (result && typeof result === "object" && !Array.isArray(result)) {
        this.reviewTokens = Array.isArray(result.tokens) ? result.tokens : [];
        if (result.entryRewards) {
          this.entryRewards = result.entryRewards;
        }
      } else {
        // Backward compat: if result is just an array
        this.reviewTokens = Array.isArray(result) ? result : [];
      }
      this.populateProductSelects();
      this.updateEntryRewardDisplays();
    } catch (error) {
      console.error("[Kaido Reviews] token fetch error", error);
      this.handleNoEligibleOrders(
        "Unable to load your orders. Please refresh the page."
      );
    }
  }

  updateEntryRewardDisplays() {
    // Update all [data-entry-reward] elements in modals and drawers
    document.querySelectorAll("[data-entry-reward]").forEach((el) => {
      const type = el.getAttribute("data-entry-reward");
      if (type && this.entryRewards[type] !== undefined) {
        el.textContent = String(this.entryRewards[type]);
      }
    });
  }

  canUseSecureTokenFlow() {
    return Boolean(this.getReviewWorkerUrl() && this.getReviewSignerUrl());
  }

  getReviewWorkerUrl() {
    const configured = (
      KAIDO_REVIEWS_CONFIG.security?.reviewWorkerUrl || ""
    ).trim();
    return configured;
  }

  getReviewSignerUrl() {
    return (KAIDO_REVIEWS_CONFIG.security?.signerEndpoint || "").trim();
  }

  async requestSignedTokenPayload() {
    const signerUrl = this.getReviewSignerUrl();
    if (!signerUrl) {
      throw new Error("Signer endpoint not configured");
    }
    const response = await fetch(signerUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: this.customerId || null,
        email: this.customerEmail || null,
        requested_at: Math.floor(Date.now() / 1000),
      }),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Unable to verify customer identity.");
    }
    if (!result.payload || !result.signature) {
      throw new Error("Signer response missing payload or signature.");
    }
    return { payload: result.payload, signature: result.signature };
  }

  async fetchTokensViaWorker() {
    const workerUrl = this.getReviewWorkerUrl();
    if (!workerUrl) {
      throw new Error("Review worker URL missing.");
    }
    const signedPayload = await this.requestSignedTokenPayload();
    const response = await fetch(workerUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Origin: window.location.origin,
      },
      body: JSON.stringify(signedPayload),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Unable to load review invites.");
    }
    return { tokens: Array.isArray(result.tokens) ? result.tokens : [], entryRewards: result.entryRewards || null };
  }

  async fetchTokensViaLegacy() {
    const endpoint = (
      KAIDO_REVIEWS_CONFIG.endpoints?.getReviewTokens || ""
    ).trim();
    if (!endpoint) {
      throw new Error("Legacy token endpoint missing.");
    }
    const params = new URLSearchParams();
    if (this.customerEmail) params.set("email", this.customerEmail);
    if (this.customerId) params.set("customer_id", this.customerId);
    const query = params.toString();
    const response = await fetch(query ? `${endpoint}?${query}` : endpoint, {
      headers: { "Content-Type": "application/json" },
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Unable to load review invites.");
    }
    return { tokens: Array.isArray(result.tokens) ? result.tokens : [], entryRewards: result.entryRewards || null };
  }

  populateProductSelects() {
    const tokens = this.reviewTokens;
    const hasTokens = tokens.length > 0;
    this.toggleNoOrdersMessage(!hasTokens);
    this.setWriteButtonsDisabled(!hasTokens);
    this.productSelects.forEach((select) => {
      this.buildProductSelectOptions(select, tokens);
    });
    if (hasTokens && tokens.length >= 1) {
      this.productSelects.forEach((select) => {
        select.value = tokens[0].token;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
      // Show the review token popup for users with available tokens
      try {
        this.showReviewTokenPopup(tokens);
      } catch (err) {
        console.error("[Kaido Reviews] Popup error:", err);
      }
    }
  }

  buildProductSelectOptions(select, tokens) {
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.dataset.productId = "";
    placeholder.textContent = tokens.length
      ? "Select a product to review"
      : "No review invites available";

    select.innerHTML = "";
    select.appendChild(placeholder);

    tokens.forEach((token) => {
      // Bug 1 fix: also skip tokens where productId is the string "0",
      // which is the Shopify/Liquid nil-object sentinel value.
      if (!token.productId || token.productId === "0") return;
      const option = document.createElement("option");
      option.value = token.token;
      option.dataset.token = token.token;
      option.dataset.productId = token.productId;
      option.textContent = this.formatTokenLabel(token);
      select.appendChild(option);
    });

    select.disabled = !tokens.length;
    if (!tokens.length) {
      select.classList.add("is-disabled");
    } else {
      select.classList.remove("is-disabled");
    }
  }

  formatTokenLabel(token) {
    const parts = [];
    if (token.productTitle) parts.push(token.productTitle);
    if (token.orderNumber) {
      parts.push(`#${token.orderNumber}`);
    } else if (token.orderName) {
      parts.push(token.orderName);
    }
    return parts.join(" · ") || "Eligible Product";
  }

  handleProductSelectChange(select) {
    const selectedOption = select.options[select.selectedIndex];
    const productId = selectedOption?.dataset.productId || "";
    const tokenId = selectedOption?.dataset.token || "";
    if (select.value) {
      select.classList.remove("is-invalid");
    }
    select.dataset.selectedProductId = productId;
    select.dataset.selectedToken = tokenId;
    const form = select.closest("form");
    if (form) {
      form.dataset.selectedProductId = productId;
      form.dataset.selectedToken = tokenId;
    }
  }

  handleNoEligibleOrders(message) {
    this.toggleNoOrdersMessage(true, message);
    this.productSelects.forEach((select) => {
      select.disabled = true;
      select.innerHTML = `<option value="" selected>No review invites available</option>`;
    });
    this.setWriteButtonsDisabled(true);
  }

  toggleNoOrdersMessage(show, customMessage) {
    this.productEmptyMessages.forEach((msg) => {
      if (typeof customMessage === "string" && customMessage.trim()) {
        msg.textContent = customMessage.trim();
      }
      msg.hidden = !show;
    });
  }

  setWriteButtonsDisabled(disabled) {
    this.writeButtons.forEach((button) => {
      button.disabled = disabled;
      button.classList.toggle("is-disabled", disabled);
      button.setAttribute("aria-disabled", String(disabled));
    });
  }

  // =============================================
  // REVIEW TOKEN POPUP
  // =============================================

  async initReviewDrawer() {
    // Independent of initProductSelectionFlow — ensures the drawer
    // appears on every page that has a reviews section, even when the
    // product-select flow takes an early return.
    if (!this.isCustomer || (!this.customerEmail && !this.customerId)) {
      // Not a customer — no review-ticket drawer will ever appear on this page.
      // Signal resolution so the social-proof popup stops waiting (v1.3).
      try {
        window.KAIDO = window.KAIDO || {};
        window.KAIDO.reviewDrawerResolved = true;
      } catch (_) {}
      return;
    }
    try {
      // Wait a tick so loadReviewTokens() (if it runs) can populate first
      await new Promise((r) => setTimeout(r, 200));
      let tokens = this.reviewTokens;
      if (!tokens || tokens.length === 0) {
        // v2.1 (2026-04-18): same worker→legacy fallback as loadReviewTokens
        let result;
        if (this.canUseSecureTokenFlow()) {
          try {
            result = await this.fetchTokensViaWorker();
          } catch (workerErr) {
            console.warn("[Kaido Reviews] Drawer worker failed, falling back to legacy:", workerErr);
            result = await this.fetchTokensViaLegacy();
          }
        } else {
          result = await this.fetchTokensViaLegacy();
        }
        if (result && typeof result === "object" && !Array.isArray(result)) {
          tokens = Array.isArray(result.tokens) ? result.tokens : [];
          if (result.entryRewards) this.entryRewards = result.entryRewards;
        } else {
          tokens = Array.isArray(result) ? result : [];
        }
      }
      if (Array.isArray(tokens) && tokens.length > 0) {
        this.showReviewTokenPopup(tokens);
      }
      this.updateEntryRewardDisplays();
    } catch (err) {
      // Drawer is non-critical — silently fail
      console.warn("[Kaido Reviews] Drawer token fetch failed:", err);
    } finally {
      // v1.3: signal resolution to the social-proof popup so it knows whether
      // to suppress itself. Set regardless of success/failure path — the new
      // popup checks both the flag AND the DOM for a drawer element.
      try {
        window.KAIDO = window.KAIDO || {};
        window.KAIDO.reviewDrawerResolved = true;
      } catch (_) {}
    }
  }

  showReviewTokenPopup(tokens) {
    if (!tokens || tokens.length === 0) return;
    if (document.querySelector(".kaido-review-drawer")) return;

    // Build drawer and tab, append to body
    const { drawer, tab } = this.createReviewDrawer(tokens);
    document.body.appendChild(drawer);
    document.body.appendChild(tab);

    this._reviewDrawer = drawer;
    this._reviewDrawerTab = tab;

    // Analytics: emit shown event (PRD v3 FR-20 / US-004)
    try {
      if (window.KAIDO && window.KAIDO.analytics) {
        window.KAIDO.analytics.trackEvent("shown", "review_ticket_drawer", {
          schema_version: 2,
          token_count: tokens.length
        });
      }
    } catch (e) { /* silent — never break the drawer */ }

    // v2 (2026-04-18): auto-open removed. Drawer opens only on user click of the
    // red→gold notification square. See review-popup-redesign-plan.md §3.1.
  }

  createReviewDrawer(tokens) {
    const firstToken = tokens[0];
    const productName = firstToken?.productTitle || "your recent purchase";
    const tokenCount = tokens.length;
    // v2: real token count capped at "9+" for the notification badge
    const badgeText = tokenCount > 9 ? "9+" : String(tokenCount);

    // --- Drawer panel ---
    const drawer = document.createElement("div");
    drawer.className = "kaido-review-drawer";
    drawer.setAttribute("role", "complementary");
    drawer.setAttribute("aria-label", "Review invitation");

    drawer.innerHTML = `
      <button class="kaido-review-drawer__close" aria-label="Close">&times;</button>
      <div class="kaido-review-drawer__header">
        <div class="kaido-review-drawer__star-icon">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
        </div>
        <div>
          <h3 class="kaido-review-drawer__title">You have ${tokenCount > 1 ? tokenCount + " products" : "a product"} to review!</h3>
          <p class="kaido-review-drawer__subtitle">Earn giveaway entries for your feedback</p>
        </div>
      </div>
      <div class="kaido-review-drawer__product">
        <span class="kaido-review-drawer__product-name">${this.escapeHtml(productName)}</span>
        ${tokenCount > 1 ? `<span class="kaido-review-drawer__product-count">+${tokenCount - 1} more</span>` : ""}
      </div>
      <div class="kaido-review-drawer__rewards">
        <div class="kaido-review-drawer__reward">
          <span class="kaido-review-drawer__reward-value">+${this.entryRewards.text}</span>
          <span class="kaido-review-drawer__reward-label">Text</span>
        </div>
        <div class="kaido-review-drawer__reward">
          <span class="kaido-review-drawer__reward-value">+${this.entryRewards.photo}</span>
          <span class="kaido-review-drawer__reward-label">Photo</span>
        </div>
        <div class="kaido-review-drawer__reward">
          <span class="kaido-review-drawer__reward-value">+${this.entryRewards.video}</span>
          <span class="kaido-review-drawer__reward-label">Video</span>
        </div>
      </div>
      <button type="button" class="kaido-review-drawer__cta">Write a Review</button>
    `;

    // --- Collapsed tab (v2: red→gold notification square with badge) ---
    const tab = document.createElement("button");
    tab.className = "kaido-review-drawer-tab kaido-review-token-tab";
    tab.setAttribute("type", "button");
    tab.setAttribute(
      "aria-label",
      `Leave a review — ${tokenCount} unclaimed reward${tokenCount === 1 ? "" : "s"}. Earn up to ${this.entryRewards.video} entries.`
    );
    // Build icon + badge via DOM methods (avoids innerHTML on untrusted-looking token count).
    const iconSpan = document.createElement("span");
    iconSpan.className = "kaido-review-token-tab__icon";
    iconSpan.setAttribute("aria-hidden", "true");
    const iconSvgNs = "http://www.w3.org/2000/svg";
    const iconSvg = document.createElementNS(iconSvgNs, "svg");
    iconSvg.setAttribute("viewBox", "0 0 24 24");
    iconSvg.setAttribute("fill", "currentColor");
    const iconPath = document.createElementNS(iconSvgNs, "path");
    iconPath.setAttribute("d", "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z");
    iconSvg.appendChild(iconPath);
    iconSpan.appendChild(iconSvg);
    const badgeSpan = document.createElement("span");
    badgeSpan.className = "kaido-review-token-tab__badge";
    badgeSpan.setAttribute("aria-hidden", "true");
    badgeSpan.textContent = badgeText;
    tab.appendChild(iconSpan);
    tab.appendChild(badgeSpan);

    // --- Event listeners ---
    drawer.querySelector(".kaido-review-drawer__close")
      .addEventListener("click", () => this.closeReviewDrawer());

    tab.addEventListener("click", () => {
      try {
        if (window.KAIDO && window.KAIDO.analytics) {
          window.KAIDO.analytics.trackEvent("tab_clicked", "review_ticket_drawer", { schema_version: 2, target: "direct_modal" });
        }
      } catch (e) { /* silent */ }
      // v2.2 (2026-04-18): skip the drawer panel; open the review modal directly.
      const isMobile = window.innerWidth <= 768;
      const selector = isMobile
        ? '[data-review-modal="mobile"]'
        : '[data-review-modal="desktop"]';
      const modal =
        this.sectionEl.querySelector(selector) ||
        document.querySelector(selector);
      if (modal) {
        modal.classList.add("is-open");
      } else {
        // Fallback: navigate to reviews page
        window.location.href = "/pages/reviews";
      }
    });

    drawer.querySelector(".kaido-review-drawer__cta")
      .addEventListener("click", () => {
        // Always try to open the review modal directly first
        const isMobile = window.innerWidth <= 768;
        const selector = isMobile
          ? '[data-review-modal="mobile"]'
          : '[data-review-modal="desktop"]';
        const modal =
          this.sectionEl.querySelector(selector) ||
          document.querySelector(selector);
        // Analytics before navigation (PRD v3 FR-20)
        try {
          if (window.KAIDO && window.KAIDO.analytics) {
            window.KAIDO.analytics.trackEvent("cta_clicked", "review_ticket_drawer", {
              schema_version: 2,
              target: modal ? "inline_modal" : "reviews_page"
            });
          }
        } catch (e) { /* silent */ }
        if (modal) {
          modal.classList.add("is-open");
          this.closeReviewDrawer();
        } else {
          // Fallback: navigate to reviews page
          window.location.href = "/pages/reviews";
        }
      });

    return { drawer, tab };
  }

  openReviewDrawer() {
    if (this._reviewDrawer) this._reviewDrawer.classList.add("is-open");
    if (this._reviewDrawerTab) {
      this._reviewDrawerTab.classList.add("is-hidden");
      // a11y: the slid-off-screen tab must not be keyboard-focusable (US-004 / US-014)
      this._reviewDrawerTab.setAttribute("tabindex", "-1");
    }
  }

  closeReviewDrawer() {
    // Analytics: close event (PRD v3 FR-20)
    try {
      if (window.KAIDO && window.KAIDO.analytics) {
        window.KAIDO.analytics.trackEvent("closed", "review_ticket_drawer", { schema_version: 2 });
      }
    } catch (e) { /* silent */ }
    if (this._reviewDrawer) this._reviewDrawer.classList.remove("is-open");
    if (this._reviewDrawerTab) {
      this._reviewDrawerTab.classList.remove("is-hidden");
      this._reviewDrawerTab.removeAttribute("tabindex");
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  attachDetailModalHandlers() {
    this.reviewDetailModals.forEach((modal) => {
      const closeModal = () => {
        /* v1.7.1 fix: openDetailModal (line ~1869) opens ALL detail modals via
           forEach  desktop `#reviewDetailOverlay-desktop` AND mobile
           `#review-detail-modal-mobile` both receive `.is-open` on any open.
           The original v1.7 close only removed `.is-open` from the modal whose
           close button was clicked, leaving the other modal still `.is-open`.
           The querySelector guard then found that stale modal and SKIPPED the
           unlock, so body stayed `position: fixed` on mobile and scroll
           appeared frozen until page refresh. Close must mirror open  remove
           `.is-open` from every detail modal so the unlock always runs. */
        this.reviewDetailModals.forEach((m) => {
          this.releaseReviewVideoSources(m);
          m.classList.remove("is-open");
        });
        document.body.classList.remove("kaido-review-detail-open");
        /* v1.7 iOS pinch-zoom fix: unlock body scroll.
           Restore saved scroll position so the user lands exactly where they were.
           v1.7.2: temporarily override `scroll-behavior: smooth` (set globally in
           base.css on <html>) so the restoring scrollTo is INSTANT. Without this,
           the browser animates from 0 → savedY which looks like a flash-to-top
           followed by a smooth scroll back down to the reviews section. */
        try {
          const savedY = parseInt(document.body.dataset.kaidoReviewLockY || "0", 10);
          const rootEl = document.documentElement;
          const prevScrollBehavior = rootEl.style.scrollBehavior;
          rootEl.style.scrollBehavior = "auto";
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.left = "";
          document.body.style.right = "";
          document.body.style.width = "";
          delete document.body.dataset.kaidoReviewLockY;
          window.scrollTo(0, savedY);
          rootEl.style.scrollBehavior = prevScrollBehavior;
        } catch (_) { /* silent */ }
      };
      modal.querySelectorAll("[data-close-review-detail]").forEach((btn) => {
        btn.addEventListener("click", closeModal);
      });
      modal.addEventListener("click", (evt) => {
        if (evt.target === modal) closeModal();
      });
    });
  }

  releaseReviewVideoSources(root) {
    if (!root || typeof root.querySelectorAll !== "function") return;
    root
      .querySelectorAll("video[data-kaido-media-src]")
      .forEach((video) => {
        video.pause();
        video.removeAttribute("src");
        video.load();
        video.remove();
      });
  }

  showModalPage(modal, step) {
    if (!modal) return;
    const pageNum = Number(step);

    // Desktop modal sliding - find the inner modal if we have the overlay
    let desktopModal = modal;
    if (
      modal.id === "writeReviewOverlay-desktop" ||
      modal.classList.contains("modal-overlay")
    ) {
      const innerModal = modal.querySelector("#reviewModal-desktop");
      if (innerModal) {
        desktopModal = innerModal;
      }
    }

    desktopModal.classList.remove("show-page-1", "show-page-2");
    if (pageNum > 1) {
      desktopModal.classList.add(`show-page-${pageNum}`);
    }

    // Mobile form sliding
    const stepsContainer = modal.querySelector(".kaido-review-form__steps");
    if (stepsContainer) {
      stepsContainer.classList.remove("show-step-1", "show-step-2");
      if (pageNum > 1) {
        stepsContainer.classList.add(`show-step-${pageNum}`);
      }
    }

    // Populate review summary when advancing to page 2
    if (pageNum === 2) {
      // Use setTimeout to ensure DOM and values are fully updated
      setTimeout(() => {
        this.populateReviewSummary(modal);
      }, 150);
    }
  }

  populateReviewSummary(modal) {
    if (!modal) return;

    const form = modal.querySelector("form[data-kaido-review-form]");
    if (!form) return;

    const summaryContainer = modal.querySelector("[data-review-summary]");
    if (!summaryContainer) return;

    // Get selected product
    const productSelect = form.querySelector("[data-product-select]");
    const selectedOption = productSelect?.options[productSelect.selectedIndex];
    const productName = selectedOption?.textContent || "Selected Product";

    // Get selected rating - check multiple sources
    const ratingInput = form.querySelector('input[name="rating"]');
    let rating = Number(ratingInput?.value || 0);

    // If rating is still 0, try to get it from the star picker
    if (rating === 0) {
      const starPicker = form.querySelector("[data-star-picker]");
      const activateStars = starPicker?.querySelectorAll(
        ".selected, .is-selected, .active, .is-active"
      );
      if (activateStars && activateStars.length > 0) {
        // Get the highest rated active star
        let maxRating = 0;
        activateStars.forEach((star) => {
          const starRating = Number(star.dataset.value || 0);
          if (starRating > maxRating) {
            maxRating = starRating;
          }
        });
        rating = maxRating;
      }
    }

    // Update product name
    const productEl = summaryContainer.querySelector("[data-summary-product]");
    if (productEl) {
      productEl.textContent = productName;
    }

    // Update rating stars (interactive)
    const ratingEl = summaryContainer.querySelector("[data-summary-rating]");
    if (ratingEl) {
      if (rating > 0) {
        ratingEl.innerHTML = this.renderStars(rating, true);
        ratingEl.style.display = "flex";

        // Make summary stars clickable to update rating
        ratingEl.addEventListener("click", (evt) => {
          let target = evt.target;

          // If clicked on path inside SVG, get the SVG parent
          if (target.tagName === "path") {
            target = target.closest("svg[data-value]");
          }

          if (!target || !target.dataset.value) return;

          const newRating = Number(target.dataset.value);

          // Update the star picker in step 1
          const starPicker = form.querySelector("[data-star-picker]");
          if (starPicker) {
            this.updateStarPicker(starPicker, newRating);
          }

          // Update the summary display
          ratingEl.innerHTML = this.renderStars(newRating, true);

          // Re-attach the click handler (since we replaced innerHTML)
          this.updateReviewSummary(form);
        });
      } else {
        ratingEl.innerHTML = "";
        ratingEl.style.display = "none";
      }
    }
  }

  renderStars(rating, interactive = false) {
    const stars = [];
    const starPath =
      '<path fill="currentColor" d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>';
    for (let i = 1; i <= 5; i++) {
      const filled = i <= rating;
      const dataAttr = interactive ? `data-value="${i}"` : '';
      const cursorClass = interactive ? 'clickable' : '';
      stars.push(
        `<svg class="star ${
          filled ? "full" : "empty"
        } ${cursorClass}" ${dataAttr} viewBox="0 0 24 24" role="${interactive ? 'button' : ''}" tabindex="${interactive ? '0' : ''}" aria-label="${i} star${i > 1 ? 's' : ''}">${starPath}</svg>`
      );
    }
    return stars.join("");
  }

  registerRequirementWatcher(input, handler) {
    if (!input || typeof handler !== "function") return;
    this.getRequirementWatchEvents(input).forEach((eventName) => {
      input.addEventListener(eventName, handler);
    });
  }

  getRequirementWatchEvents(input) {
    const tag = input?.tagName?.toLowerCase();
    if (tag === "select") return ["change"];
    return ["input", "change"];
  }

  inputRequirementHasValue(input) {
    if (!input) return false;
    const tag = input.tagName ? input.tagName.toLowerCase() : "";
    if (tag === "input") {
      const typeAttr = (input.getAttribute("type") || "").toLowerCase();
      if (typeAttr === "checkbox" || typeAttr === "radio") {
        return Boolean(input.checked);
      }
    }
    const rawValue =
      typeof input.value === "string" ? input.value.trim() : input.value;
    return Boolean(rawValue);
  }

  updateStarPicker(container, value) {
    const closestForm =
      typeof container.closest === "function"
        ? container.closest("form")
        : null;
    const hiddenInput = closestForm
      ? closestForm.querySelector('input[name="rating"]')
      : null;
    if (hiddenInput) {
      hiddenInput.value = value;
      ["input", "change"].forEach((eventName) => {
        hiddenInput.dispatchEvent(new Event(eventName, { bubbles: true }));
      });
    }
    container.querySelectorAll("[data-value]").forEach((node) => {
      const starValue = Number(node.dataset.value);
      const isActive = starValue <= value;
      node.classList.toggle("is-active", isActive);
      node.classList.toggle("active", isActive);
      const tag = node.tagName ? node.tagName.toLowerCase() : "";
      const role =
        typeof node.getAttribute === "function"
          ? node.getAttribute("role")
          : null;
      const pressable = tag === "button" || role === "button";
      if (pressable) {
        node.setAttribute("aria-pressed", isActive ? "true" : "false");
      }
      const svgTargets =
        node.tagName && node.tagName.toLowerCase() === "svg"
          ? [node]
          : node.querySelectorAll("svg");
      svgTargets.forEach((svg) => {
        svg.classList.toggle("is-selected", isActive);
        svg.classList.toggle("selected", isActive);
      });
    });
    const hasValue = Boolean(value);
    container.classList.toggle("has-value", hasValue);
    container.classList.toggle("selected", hasValue);
  }

  openLoginModal() {
    if (this.loginModal) {
      this.loginModal.classList.add("is-open");
    } else if (this.loginUrl) {
      window.location.href = this.loginUrl;
    }
  }

  canSubmitReview() {
    return Boolean(this.reviewToken || this.isCustomer);
  }

  getProductSelectionForForm(form) {
    const select = form ? form.querySelector("[data-product-select]") : null;
    if (!select) {
      return {
        productId: this.productId || null,
        token: this.reviewToken || null,
      };
    }
    const selectedOption = select.options[select.selectedIndex];
    const productId =
      select.dataset.selectedProductId ||
      selectedOption?.dataset.productId ||
      this.productId ||
      null;
    const tokenId =
      select.dataset.selectedToken || selectedOption?.dataset.token || null;
    return { productId, token: tokenId };
  }

  getFormModal(form) {
    if (!form) return null;
    if (typeof form.closest !== "function") return null;
    return form.closest("[data-review-modal]");
  }

  autoAdvanceStep(form, stepNumber) {
    if (!stepNumber) return;
    const modal = this.getFormModal(form);
    if (!modal) return;
    this.showModalPage(modal, stepNumber);
  }

  setLoading(isLoading) {
    this.loadingNodes.forEach((node) => (node.hidden = !isLoading));
  }

  resetPagination() {
    this.pagination.mediaPage = 1;
    this.pagination.textPage = 1;
    this.pagination.textOffset = 0;
    this.pagination.mediaExhausted = false;
    this.pagination.textExhausted = false;
    this.renderedReviewKeys.clear();
  }

  shouldPrioritizeMedia() {
    return this.currentFilters.media === "any";
  }

  getReviewKey(review) {
    if (!review) return "";
    return (
      review.id ||
      review.review_id ||
      review.token_id ||
      `${review.product_id || ""}|${review.author_name || ""}|${
        review.created_at || ""
      }|${review.title || ""}`
    );
  }

  filterNewReviews(reviews) {
    const output = [];
    (reviews || []).forEach((review) => {
      const key = this.getReviewKey(review);
      if (!key) {
        output.push(review);
        return;
      }
      if (this.renderedReviewKeys.has(key)) return;
      this.renderedReviewKeys.add(key);
      output.push(review);
    });
    return output;
  }

  setLoadMoreLoading(isLoading) {
    this.loadMoreButtons.forEach((btn) => {
      btn.disabled = isLoading;
      btn.classList.toggle("is-loading", isLoading);
      if (isLoading) {
        btn.textContent = "Loading...";
      } else {
        btn.textContent = "Load more reviews";
      }
    });
  }

  updateLoadMoreVisibility() {
    const hasMore = !(
      this.pagination.mediaExhausted && this.pagination.textExhausted
    );
    // Also check if the grid has any rendered content at all
    const hasRenderedReviews = this.renderedReviewKeys.size > 0;
    this.loadMoreButtons.forEach((btn) => {
      // Hide entirely when there are no more pages OR when grid is empty
      btn.hidden = !hasMore || !hasRenderedReviews;
      btn.disabled = !hasMore;
      btn.classList.toggle("is-disabled", !hasMore);
      if (!btn.classList.contains("is-loading")) {
        btn.textContent = "Load more reviews";
      }
    });
  }

  async fetchReviewsPage(params) {
    const query = new URLSearchParams(params);
    const response = await fetch(
      `${KAIDO_REVIEWS_CONFIG.endpoints.getReviews}?${query.toString()}`
    );
    if (!response.ok)
      throw new Error(`Failed to fetch reviews (${response.status})`);
    return response.json();
  }

  async fetchAndRenderReviews(options = {}) {
    const { append = false } = options;
    const isInitial = !append;
    if (append && this.pagination.mediaExhausted && this.pagination.textExhausted) {
      this.updateLoadMoreVisibility();
      return;
    }
    if (isInitial) {
      this.setLoading(true);
      this.resetPagination();
      this.currentFilters.page = 1;
    } else {
      this.setLoadMoreLoading(true);
    }

    try {
      const pageSize = this.pagination.pageSize;
      const baseParams = {
        page_size: String(pageSize),
        sort: this.currentFilters.sort || "recent",
        include_stats: "1",
      };
      if (this.productId) baseParams.product_id = this.productId;
      if (this.currentFilters.rating && this.currentFilters.rating !== "all") {
        baseParams.rating = this.currentFilters.rating;
      }

      const prioritizeMedia = this.shouldPrioritizeMedia();
      let reviews = [];
      let stats = null;

      if (prioritizeMedia) {
        const mediaData = await this.fetchReviewsPage({
          ...baseParams,
          page: String(this.pagination.mediaPage),
          has_media: "true",
        });
        stats = mediaData.stats || null;
        const mediaReviews = mediaData.reviews || [];
        reviews = reviews.concat(mediaReviews);

        if (mediaReviews.length < pageSize) {
          this.pagination.mediaExhausted = true;
        } else {
          this.pagination.mediaPage += 1;
        }

        if (reviews.length < pageSize) {
          const remaining = pageSize - reviews.length;
          const textData = await this.fetchReviewsPage({
            ...baseParams,
            page: String(this.pagination.textPage),
            has_media: "false",
          });
          if (!stats && textData.stats) stats = textData.stats;
          const textReviews = textData.reviews || [];
          const slice = textReviews.slice(
            this.pagination.textOffset,
            this.pagination.textOffset + remaining
          );
          reviews = reviews.concat(slice);
          this.pagination.textOffset += slice.length;

          if (this.pagination.textOffset >= textReviews.length) {
            this.pagination.textPage += 1;
            this.pagination.textOffset = 0;
            if (textReviews.length < pageSize) {
              this.pagination.textExhausted = true;
            }
          }
          if (textReviews.length === 0) {
            this.pagination.textExhausted = true;
          }
        }
      } else {
        if (append) this.currentFilters.page += 1;
        const page = this.currentFilters.page || 1;
        if (this.currentFilters.media && this.currentFilters.media !== "any") {
          baseParams.has_media = this.currentFilters.media;
        }
        const data = await this.fetchReviewsPage({
          ...baseParams,
          page: String(page),
        });
        stats = data.stats || null;
        reviews = data.reviews || [];
        if (reviews.length < pageSize) {
          this.pagination.mediaExhausted = true;
          this.pagination.textExhausted = true;
        } else {
          this.pagination.mediaExhausted = false;
          this.pagination.textExhausted = false;
        }
      }

      const uniqueReviews = this.filterNewReviews(reviews);
      this.renderReviews(uniqueReviews, { append: !isInitial });
      if (isInitial) {
        this.updateSummary(stats || {}, uniqueReviews);
        this.toggleEmptyState(uniqueReviews.length === 0);
      } else if (uniqueReviews.length === 0) {
        this.pagination.mediaExhausted = true;
        this.pagination.textExhausted = true;
      }
      this.updateLoadMoreVisibility();
    } catch (error) {
      
      console.error("[Kaido Reviews] fetch error", error);
      if (isInitial) {
        this.showErrorState("Unable to load reviews. Please try again later.");
      } else if (typeof window !== "undefined" && typeof window.kaidoToast === "function") {
        window.kaidoToast({
          title: "Reviews",
          message: "Unable to load more reviews right now. Please try again later.",
        });
      }
    } finally {
      if (isInitial) this.setLoading(false);
      this.setLoadMoreLoading(false);
    }
  }

  renderReviews(reviews, options = {}) {
    const { append = false } = options;
    if (!append) {
      if (this.reviewsGridDesktop) this.reviewsGridDesktop.innerHTML = "";
      if (this.reviewsGridMobile) this.reviewsGridMobile.innerHTML = "";
    }

    const { media: mediaReviews, text: textReviews } =
      this.partitionReviewsByMedia(reviews);
    const ordered = [...mediaReviews, ...textReviews];

    ordered.forEach((review, index) => {
      if (
        this.reviewsGridDesktop &&
        this.templates.desktop &&
        this.templates.desktop.content
      ) {
        const card = this.templates.desktop.content.cloneNode(true);
        this.populateDesktopCard(card, review);
        this.reviewsGridDesktop.appendChild(card);
      }
      if (
        this.reviewsGridMobile &&
        this.templates.mobile &&
        this.templates.mobile.content
      ) {
        const card = this.templates.mobile.content.cloneNode(true);
        this.populateMobileCard(card, review);
        this.reviewsGridMobile.appendChild(card);
      }

      // Insert a separator between media and text groups for desktop to reduce layout jumps
      const isLastMedia =
        review.has_media &&
        mediaReviews.length &&
        index === mediaReviews.length - 1 &&
        textReviews.length > 0;
      if (isLastMedia && this.reviewsGridDesktop) {
        const spacer = document.createElement("div");
        spacer.className = "kaido-reviews__grid-row-break-desktop";
        this.reviewsGridDesktop.appendChild(spacer);
      }
      // Insert a separator for mobile too
      if (isLastMedia && this.reviewsGridMobile) {
        const spacerMobile = document.createElement("div");
        spacerMobile.className = "kaido-reviews__grid-row-break";
        this.reviewsGridMobile.appendChild(spacerMobile);
      }
    });

    this.bindCardClicks();
  }

  populateDesktopCard(fragment, review) {
    const article = fragment.querySelector(".review-card");
    article._mediaItems = Array.isArray(review.review_media)
      ? review.review_media
      : [];
    article.dataset.rating = review.rating || 0;
    article.dataset.title = review.title || "";
    article.dataset.body = review.body || "";
    article.dataset.author = review.author_name || "Anonymous";
    article.dataset.mediaType = review.has_media ? "media" : "none";
    article.dataset.verified = review.verified_purchase ? "true" : "false";
    article.dataset.productId = review.product_id || "";
    article.dataset.productTitle = review.product_title || "";
    article.dataset.mediaPayload = encodeURIComponent(
      JSON.stringify(review.review_media || [])
    );

    fragment.querySelector('[data-field="author"]').textContent =
      review.author_name || "Anonymous";
    fragment.querySelector('[data-field="title"]').textContent =
      review.title || "";
    fragment.querySelector('[data-field="body"]').textContent =
      review.body || "";
    const productLabel = fragment.querySelector('[data-field="product"]');
    if (productLabel) {
      const productTitle =
        review.product_title ||
        review.product_name ||
        review.product_handle ||
        "";
      if (productTitle) {
        productLabel.textContent = productTitle;
        productLabel.hidden = false;
      } else {
        productLabel.hidden = true;
      }
    }
    fragment.querySelector('[data-field="stars"]').innerHTML =
      this.renderStarIcons(review.rating || 0);

    const verified = fragment.querySelector('[data-field="verified"]');
    if (verified) {
      if (review.verified_purchase) {
        verified.hidden = false;
      } else {
        verified.hidden = true;
      }
    }

    const mediaContainer = fragment.querySelector('[data-field="media"]');
    this.populateMediaPreview(mediaContainer, review);
  }

  populateMobileCard(fragment, review) {
    const card = fragment.querySelector(".kaido-reviews__card");
    card._mediaItems = Array.isArray(review.review_media)
      ? review.review_media
      : [];
    card.dataset.mediaType = review.has_media ? "media" : "none";
    card.dataset.title = review.title || "";
    card.dataset.body = review.body || "";
    card.dataset.author = review.author_name || "Anonymous";
    card.dataset.rating = review.rating || 0;
    card.dataset.verified = review.verified_purchase ? "true" : "false";
    card.dataset.productId = review.product_id || "";
    card.dataset.productTitle = review.product_title || "";
    card.dataset.mediaPayload = encodeURIComponent(
      JSON.stringify(review.review_media || [])
    );

    fragment.querySelector('[data-field="title"]').textContent =
      review.title || "";
    fragment.querySelector('[data-field="body"]').textContent =
      review.body || "";

    // Set author text in the author container (not inside verified badge)
    const authorContainer = fragment.querySelector('[data-field="author"]');
    const authorTextNode = document.createTextNode(
      review.author_name || "Anonymous"
    );
    // Clear and add text before the verified badge
    const firstChild = authorContainer.firstChild;
    if (firstChild && firstChild.nodeType === Node.TEXT_NODE) {
      authorContainer.replaceChild(authorTextNode, firstChild);
    } else {
      authorContainer.insertBefore(authorTextNode, authorContainer.firstChild);
    }

    fragment.querySelector('[data-field="stars"]').innerHTML =
      this.renderStarIcons(review.rating || 0);

    const verified = fragment.querySelector('[data-field="verified"]');
    if (verified) {
      if (review.verified_purchase) {
        verified.hidden = false;
      } else {
        verified.hidden = true;
      }
    }
    const productLabel = fragment.querySelector('[data-field="product"]');
    if (productLabel) {
      const productTitle =
        review.product_title ||
        review.product_name ||
        review.product_handle ||
        "";
      if (productTitle) {
        productLabel.textContent = productTitle;
        productLabel.hidden = false;
      } else {
        productLabel.hidden = true;
      }
    }

    const mediaContainer = fragment.querySelector('[data-field="media"]');
    this.populateMediaPreview(mediaContainer, review);
  }

  populateMediaPreview(container, review) {
    if (!container) return;
    container.innerHTML = "";
    const firstMedia = (review.review_media || [])[0];
    if (!firstMedia) {
      container.hidden = true;
      container.style.display = "none";
      return;
    }
    container.hidden = false;
    container.style.display = "";
    const { primary, fallback } = this.getImageUrls(firstMedia);
    if (firstMedia.media_type === "image") {
      const img = document.createElement("img");
      img.loading = "lazy";
      img.decoding = "async";
      img.src = primary;
      if (fallback && fallback !== primary) {
        img.onerror = () => {
          img.onerror = null;
          img.src = fallback;
        };
      }
      img.alt = `Review media from ${review.author_name || "customer"}`;
      container.appendChild(img);
    } else if (firstMedia.media_type === "video") {
      const poster = primary || fallback;
      if (poster) {
        const img = document.createElement("img");
        img.loading = "lazy";
        img.decoding = "async";
        img.src = poster;
        img.alt = `Video review from ${review.author_name || "customer"}`;
        container.appendChild(img);
      } else {
        const placeholder = document.createElement("span");
        placeholder.className = "kaido-reviews__video-placeholder";
        placeholder.setAttribute("aria-hidden", "true");
        container.appendChild(placeholder);
      }

      const playBadge = document.createElement("span");
      playBadge.className = "kaido-reviews__video-play-badge";
      playBadge.setAttribute("aria-hidden", "true");
      playBadge.textContent = "Play";
      container.appendChild(playBadge);
    }
    container.hidden = false;
  }

  renderStarIcons(rating) {
    const full = Math.floor(rating);
    const partial = rating % 1;
    let html = "";
    for (let i = 1; i <= 5; i++) {
      const pct = i <= full ? 100 : i === full + 1 ? partial * 100 : 0;
      html += `
        <span class="star-wrapper">
          <svg class="star empty" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${STAR_PATH}</svg>
          <svg class="star full" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="clip-path: inset(0 ${
            100 - pct
          }% 0 0);">${STAR_PATH}</svg>
        </span>
      `;
    }
    return html;
  }

  buildMediaUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    const sanitized = path.replace(/^\/+/, "");
    const withBucket = sanitized.startsWith("reviews/")
      ? sanitized
      : `reviews/${sanitized}`;
    return `https://api.kaidomotors.com/storage/v1/object/public/${encodeURI(
      withBucket
    )}`;
  }

  getImageUrls(media) {
    const storagePath = media?.storage_path || "";
    const thumbPath = media?.derivative_paths?.thumb_400 || "";
    const isVideo = (media?.media_type || "").toLowerCase() === "video";
    const primaryPath = thumbPath || (isVideo ? "" : storagePath);
    const fallbackPath = !isVideo ? storagePath : "";
    const primary = primaryPath ? this.buildMediaUrl(primaryPath) : "";
    const fallback =
      thumbPath && fallbackPath && thumbPath !== fallbackPath
        ? this.buildMediaUrl(fallbackPath)
        : null;
    return { primary, fallback };
  }

  bindCardClicks() {
    const detailCards = this.sectionEl.querySelectorAll(
      ".review-card, .kaido-reviews__card"
    );
    detailCards.forEach((card) => {
      card.addEventListener("click", () => this.openDetailModal(card));
    });
  }

  openDetailModal(card) {
    let mediaItems = Array.isArray(card._mediaItems)
      ? card._mediaItems.filter(Boolean)
      : [];
    if (!mediaItems.length) {
      try {
        const mediaPayload = card.dataset.mediaPayload
          ? JSON.parse(decodeURIComponent(card.dataset.mediaPayload))
          : [];
        mediaItems = Array.isArray(mediaPayload)
          ? mediaPayload.filter(Boolean)
          : [];
      } catch (error) {
        console.warn("[Kaido Reviews] media payload parse failed", error);
        mediaItems = [];
      }
    }
    this.reviewDetailModals.forEach((modal) => {
      modal._mediaItems = mediaItems;
      modal._mediaIndex = 0;
      /* v1.7 iOS pinch-zoom fix: lock body scroll BEFORE opening the modal.
         Uses Jay Freestone's position:fixed + top:-scrollY pattern. This is the
         only pattern that survives pinch-zoom-out on iOS Safari without corrupting
         the render tree. Only lock if not already locked (first modal to open). */
      if (!document.body.dataset.kaidoReviewLockY) {
        try {
          const lockY = window.scrollY || document.documentElement.scrollTop || 0;
          document.body.dataset.kaidoReviewLockY = String(lockY);
          document.body.style.position = "fixed";
          document.body.style.top = "-" + lockY + "px";
          document.body.style.left = "0";
          document.body.style.right = "0";
          document.body.style.width = "100%";
        } catch (_) { /* silent */ }
      }
      modal.classList.add("is-open");
      document.body.classList.add("kaido-review-detail-open");
      modal
        .querySelectorAll("[data-detail-title]")
        .forEach((node) => (node.textContent = card.dataset.title || ""));
      modal
        .querySelectorAll("[data-detail-body]")
        .forEach((node) => (node.textContent = card.dataset.body || ""));
      modal
        .querySelectorAll("[data-detail-author]")
        .forEach(
          (node) => (node.textContent = card.dataset.author || "Anonymous")
        );
      modal
        .querySelectorAll("[data-detail-stars]")
        .forEach(
          (node) =>
            (node.innerHTML = this.renderStarIcons(
              Number(card.dataset.rating) || 0
            ))
        );
      modal.querySelectorAll("[data-detail-verified]").forEach((badge) => {
        badge.hidden = card.dataset.verified !== "true";
      });
      modal.querySelectorAll("[data-detail-media]").forEach((container) => {
        this.renderDetailMedia(modal, container, 0);
      });
      // Product card + fallback product image
      const productTitle = card.dataset.productTitle || "";
      const productId = card.dataset.productId || "";
      modal.querySelectorAll("[data-detail-product]").forEach((el) => {
        if (!productTitle) {
          el.hidden = true;
          return;
        }
        el.hidden = false;
        el.removeAttribute("hidden");
        const nameEl = el.querySelector("[data-detail-product-name]");
        if (nameEl) nameEl.textContent = productTitle;
        const imgEl = el.querySelector("[data-detail-product-img]");
        if (imgEl) imgEl.src = "";
        el.href = "#";
        this.resolveProductInfo(productId, productTitle).then((info) => {
          if (info.url) el.href = info.url;
          if (info.image && imgEl) {
            imgEl.src = info.image;
            imgEl.hidden = false;
          }
          // If review has no media, show product image as fallback
          if (info.image && !mediaItems.length) {
            modal.querySelectorAll("[data-detail-media]").forEach((container) => {
              if (!container.querySelector(".review-detail-product-fallback")) {
                container.innerHTML = "";
                container._carousel = null;
                container.hidden = false;
                container.removeAttribute("hidden");
                container.style.display = "block";
                const fallbackImg = document.createElement("img");
                fallbackImg.className = "review-detail-product-fallback";
                fallbackImg.src = info.image;
                fallbackImg.alt = productTitle;
                container.appendChild(fallbackImg);
              }
            });
          }
        });
      });
    });
  }

  async resolveProductInfo(productId, productTitle) {
    if (!this._productInfoCache) this._productInfoCache = new Map();
    const cacheKey = productId || productTitle;
    if (this._productInfoCache.has(cacheKey)) {
      return this._productInfoCache.get(cacheKey);
    }
    const info = { url: null, image: null };
    try {
      const q = encodeURIComponent(productTitle);
      const res = await fetch(
        `/search/suggest.json?q=${q}&resources[type]=product&resources[limit]=1`
      );
      if (res.ok) {
        const data = await res.json();
        const product = data?.resources?.results?.products?.[0];
        if (product?.url) info.url = product.url;
        if (product?.featured_image?.url) info.image = product.featured_image.url;
        else if (product?.image) info.image = product.image;
      }
    } catch (err) {
      console.warn("[Kaido Reviews] product info resolve failed", err);
    }
    if (!info.url) info.url = `/collections/all?q=${encodeURIComponent(productTitle)}`;
    this._productInfoCache.set(cacheKey, info);
    return info;
  }

  renderDetailMedia(modal, container, targetIndex = 0) {
    if (!container) return;
    const items = Array.isArray(modal._mediaItems) ? modal._mediaItems : [];
    if (!items.length) {
      container.innerHTML = "";
      container.hidden = true;
      container._carousel = null;
      return;
    }
    // If carousel DOM was removed (e.g. by fallback image), rebuild it
    if (container._carousel && !container.contains(container._carousel.frame)) {
      container._carousel = null;
    }
    const clampedIndex = Math.min(Math.max(targetIndex, 0), items.length - 1);
    modal._mediaIndex = clampedIndex;
    container.hidden = false;
    container.removeAttribute("hidden");
    container.style.display = "block";
    const isDesktopModal = modal && modal.id === "reviewDetailModal-desktop";
    const desktopMediaMaxHeight = isDesktopModal ? "40vh" : "75vh";
    const desktopMediaMaxWidth = isDesktopModal ? "50%" : "100%";
    if (isDesktopModal) {
      container.style.setProperty("height", "auto", "important");
      container.style.setProperty("max-height", "none", "important");
    }

    // initialize carousel structure once
    if (!container._carousel) {
      const wrapper = document.createElement("div");
      wrapper.className = "review-detail-media";

      const frame = document.createElement("div");
      frame.className = "review-detail-media__frame";
      frame.style.display = "flex";
      frame.style.alignItems = "center";
      frame.style.justifyContent = "center";
      if (isDesktopModal) {
        frame.style.setProperty("width", "100%", "important");
        frame.style.setProperty("height", "auto", "important");
        frame.style.setProperty("max-height", "none", "important");
      }

      const img = document.createElement("img");
      img.className = "review-detail-media__img";

      let touchStartX = null;
      frame.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0]?.clientX || null;
        },
        { passive: true }
      );
      frame.addEventListener(
        "touchend",
        (e) => {
          if (touchStartX == null) return;
          const endX = e.changedTouches[0]?.clientX || touchStartX;
          const delta = endX - touchStartX;
          if (Math.abs(delta) > 30) {
            this.changeDetailMedia(modal, container, delta < 0 ? 1 : -1);
          }
          touchStartX = null;
        },
        { passive: true }
      );

      frame.appendChild(img);
      wrapper.appendChild(frame);

      const nav = document.createElement("div");
      nav.className = "review-detail-nav";
      const prev = document.createElement("button");
      prev.type = "button";
      prev.className = "review-detail-nav__btn review-detail-nav__btn--prev";
      prev.textContent = "‹";
      prev.addEventListener("click", () =>
        this.changeDetailMedia(modal, container, -1)
      );
      const next = document.createElement("button");
      next.type = "button";
      next.className = "review-detail-nav__btn review-detail-nav__btn--next";
      next.textContent = "›";
      next.addEventListener("click", () =>
        this.changeDetailMedia(modal, container, 1)
      );
      const counter = document.createElement("span");
      counter.className = "review-detail-nav__counter";
      nav.appendChild(prev);
      nav.appendChild(counter);
      nav.appendChild(next);

      const dots = document.createElement("div");
      dots.className = "review-detail-dots";

      const overlay = document.createElement("div");
      overlay.className = "review-detail-overlay";
      overlay.appendChild(nav);
      overlay.appendChild(dots);

      container.innerHTML = "";
      container.appendChild(wrapper);
      container.appendChild(overlay);
      container._carousel = {
        img,
        frame,
        nav,
        counter,
        dots,
        prev,
        next,
        overlay,
      };
    }

    const { img, frame, counter, dots, prev, next, nav, overlay } =
      container._carousel;
    const current = items[clampedIndex];
    this.releaseReviewVideoSources(frame);
    frame.innerHTML = "";
    if (current.media_type === "image") {
      const originalPath = current?.storage_path || "";
      const originalUrl = originalPath ? this.buildMediaUrl(originalPath) : "";
      const { primary: thumbUrl } = this.getImageUrls(current);
      const viewImg = img || document.createElement("img");
      viewImg.className = "review-detail-media__img";
      viewImg.src = originalUrl || thumbUrl;
      const imageMaxHeight = isDesktopModal ? desktopMediaMaxHeight : "100%";
      viewImg.style.setProperty("width", "auto", "important");
      viewImg.style.setProperty("height", "auto", "important");
      viewImg.style.setProperty("min-width", "0", "important");
      viewImg.style.setProperty("min-height", "0", "important");
      viewImg.style.setProperty("max-width", desktopMediaMaxWidth, "important");
      viewImg.style.setProperty("max-height", imageMaxHeight, "important");
      viewImg.style.setProperty("object-fit", "contain", "important");
      viewImg.style.setProperty("object-position", "center", "important");
      viewImg.style.display = "block";
      if (originalUrl && thumbUrl && thumbUrl !== originalUrl) {
        viewImg.onerror = () => {
          viewImg.onerror = null;
          viewImg.src = thumbUrl;
        };
      }
      viewImg.alt = "Review media";
      frame.appendChild(viewImg);
      container._carousel.img = viewImg;
    } else if (current.media_type === "video") {
      const posterPath = this.getImageUrls(current).primary || "";
      const video = document.createElement("video");
      const isMobileModal = modal?.classList?.contains("kaido-modal");
      const togglePlayback = (event) => {
        if (event) event.stopPropagation();
        if (video.paused) {
          if (!video.hasAttribute("src")) {
            const mediaSrc = video.dataset.kaidoMediaSrc || "";
            if (!mediaSrc) return;
            video.src = mediaSrc;
            video.load();
          }
          const playResult = video.play();
          if (playResult && typeof playResult.catch === "function") {
            playResult.catch((error) => {
              console.warn("[Kaido Reviews] video playback failed", error);
            });
          }
        } else {
          video.pause();
        }
      };
      const videoMaxHeight = isMobileModal ? "100%" : desktopMediaMaxHeight;
      video.dataset.kaidoMaxWidth = isMobileModal
        ? "100%"
        : desktopMediaMaxWidth;
      video.dataset.kaidoMaxHeight = videoMaxHeight;
      video.controls = false;
      video.removeAttribute("controls");
      video.setAttribute(
        "controlslist",
        "nodownload nofullscreen noremoteplayback"
      );
      video.setAttribute("disablepictureinpicture", "");
      video.disablePictureInPicture = true;
      video.playsInline = true;
      video.preload = "none";
      video.dataset.kaidoMaxWidth = isMobileModal
        ? "100%"
        : desktopMediaMaxWidth;
      video.dataset.kaidoMaxHeight = videoMaxHeight;
      if (posterPath) video.poster = posterPath;
      video.dataset.kaidoMediaSrc = this.buildMediaUrl(current.storage_path);
      video.style.width = "auto";
      video.style.height = "auto";
      video.style.setProperty("min-width", "0", "important");
      video.style.setProperty("min-height", "0", "important");
      video.style.setProperty(
        "max-width",
        isMobileModal ? "100%" : desktopMediaMaxWidth,
        "important"
      );
      video.style.setProperty("max-height", videoMaxHeight, "important");
      video.dataset.kaidoMaxWidth = isMobileModal
        ? "100%"
        : desktopMediaMaxWidth;
      video.dataset.kaidoMaxHeight = videoMaxHeight;
      video.style.setProperty("object-fit", "contain", "important");
      video.style.backgroundColor = "#fff";
      video.style.setProperty("pointer-events", "auto", "important");
      video.style.setProperty("position", "relative", "important");
      video.style.setProperty("z-index", "10", "important");
      frame.appendChild(video);

      video.addEventListener("click", togglePlayback);
      const playButton = document.createElement("button");
      playButton.type = "button";
      playButton.className = "review-detail-play";
      playButton.setAttribute("aria-label", "Play review video");
      playButton.title = "Play video";
      playButton.addEventListener("click", togglePlayback);
      const syncButton = () => {
        playButton.classList.toggle("is-hidden", !video.paused);
      };
      video.addEventListener("play", syncButton);
      video.addEventListener("pause", syncButton);
      video.addEventListener("ended", syncButton);
      syncButton();
      frame.appendChild(playButton);
      frame.appendChild(this.buildMobileVideoControls(video));
    }

    if (counter) counter.textContent = `${clampedIndex + 1}/${items.length}`;

    if (prev && next && nav) {
      const stuckLeft = clampedIndex === 0;
      const stuckRight = clampedIndex === items.length - 1;
      prev.disabled = stuckLeft;
      next.disabled = stuckRight;
      prev.classList.toggle("is-disabled", stuckLeft);
      next.classList.toggle("is-disabled", stuckRight);
      const showNav = items.length > 1;
      nav.style.display = showNav ? "flex" : "none";
      if (overlay) overlay.style.display = showNav ? "block" : "none";
    }

    if (dots) {
      dots.innerHTML = "";
      if (items.length > 1) {
        dots.style.display = "flex";
        items.forEach((_, idx) => {
          const dot = document.createElement("span");
          dot.className = "review-detail-dot";
          if (idx === clampedIndex) dot.classList.add("is-active");
          dots.appendChild(dot);
        });
      } else {
        dots.style.display = "none";
      }
    }
  }

  buildMobileVideoControls(video) {
    const controls = document.createElement("div");
    controls.className = "review-detail-controls";

    const timeline = document.createElement("input");
    timeline.type = "range";
    timeline.className = "review-detail-controls__timeline";
    timeline.min = "0";
    timeline.max = "1000";
    timeline.value = "0";
    timeline.step = "1";
    timeline.setAttribute("aria-label", "Video progress");

    const timeLabel = document.createElement("span");
    timeLabel.className = "review-detail-controls__time";
    timeLabel.textContent = "0:00 / --:--";

    const fullscreenToggle = document.createElement("button");
    fullscreenToggle.type = "button";
    fullscreenToggle.className = "review-detail-controls__fullscreen";
    fullscreenToggle.setAttribute("aria-label", "Toggle fullscreen");
    fullscreenToggle.title = "Fullscreen";

    let isDragging = false;
    const frame =
      video.closest(".review-detail-media__frame") || video.parentElement;

    const toggleFullscreen = () => {
      const doc = document;
      const fullscreenEl =
        doc.fullscreenElement ||
        doc.webkitFullscreenElement ||
        doc.msFullscreenElement;
      if (fullscreenEl) {
        if (doc.exitFullscreen) {
          doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
          doc.webkitExitFullscreen();
        } else if (doc.msExitFullscreen) {
          doc.msExitFullscreen();
        }
        return;
      }
      const target = frame || video;
      if (target && target.requestFullscreen) {
        target.requestFullscreen();
      } else if (target && target.webkitRequestFullscreen) {
        target.webkitRequestFullscreen();
      } else if (target && target.msRequestFullscreen) {
        target.msRequestFullscreen();
      } else if (typeof video.webkitEnterFullscreen === "function") {
        video.webkitEnterFullscreen();
      }
    };

    const updateFullscreenLayout = () => {
      const doc = document;
      const fullscreenEl =
        doc.fullscreenElement ||
        doc.webkitFullscreenElement ||
        doc.msFullscreenElement;
      if (fullscreenEl) {
        video.style.setProperty("max-width", "100%", "important");
        video.style.setProperty("max-height", "100%", "important");
      } else {
        const maxWidth = video.dataset.kaidoMaxWidth || "";
        const maxHeight = video.dataset.kaidoMaxHeight || "";
        if (maxWidth) {
          video.style.setProperty("max-width", maxWidth, "important");
        }
        if (maxHeight) {
          video.style.setProperty("max-height", maxHeight, "important");
        }
      }
    };

    const updateTime = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const current = Number.isFinite(video.currentTime)
        ? video.currentTime
        : 0;
      if (!isDragging && duration > 0) {
        timeline.value = String(Math.round((current / duration) * 1000));
      }
      const totalLabel = duration ? this.formatMediaTime(duration) : "--:--";
      timeLabel.textContent = `${this.formatMediaTime(
        current
      )} / ${totalLabel}`;
    };

    const syncControlWidth = () => {
      const videoRectWidth = video.getBoundingClientRect().width || 0;
      const isDesktopDetail = Boolean(
        video.closest("#reviewDetailModal-desktop")
      );
      const frameWidth = frame?.clientWidth || 0;
      const frameHeight = frame?.clientHeight || 0;
      const videoWidth = video.videoWidth || 0;
      const videoHeight = video.videoHeight || 0;
      let baseWidth = videoRectWidth || 0;
      if (
        !baseWidth &&
        frameWidth &&
        frameHeight &&
        videoWidth &&
        videoHeight
      ) {
        const scale = Math.min(
          frameWidth / videoWidth,
          frameHeight / videoHeight,
          1
        );
        baseWidth = Math.max(0, Math.round(videoWidth * scale));
      }
      if (!baseWidth && frameWidth) {
        baseWidth = Math.round(frameWidth);
      }
      if (!baseWidth) return;

      // For desktop detail modal, let CSS handle width/positioning
      if (isDesktopDetail) {
        const doc = document;
        const isFullscreen = !!(
          doc.fullscreenElement ||
          doc.webkitFullscreenElement ||
          doc.msFullscreenElement
        );

        if (isFullscreen) {
          // In fullscreen, dynamically set width to match video
          const controlWidth = Math.max(0, Math.round(baseWidth * 0.9));
          if (controlWidth > 0) {
            controls.style.width = `${controlWidth}px`;
          }
        } else {
          // Not in fullscreen, let CSS handle it (300px default)
          controls.style.removeProperty("width");
        }

        // Don't override positioning - CSS handles it
        controls.style.removeProperty("left");
        controls.style.removeProperty("right");
        controls.style.removeProperty("bottom");
        controls.style.removeProperty("top");
        controls.style.removeProperty("position");
        controls.style.removeProperty("transform");
        controls.style.removeProperty("margin-left");
        controls.style.removeProperty("margin-right");
        controls.style.removeProperty("margin-top");
        controls.style.removeProperty("margin-bottom");
      } else {
        // For mobile, use 100% of video width for controls to match exactly
        const controlWidth = Math.max(0, Math.round(baseWidth));
        if (controlWidth > 0) {
          controls.style.width = `${controlWidth}px`;
        }
        controls.style.left = "50%";
        controls.style.right = "auto";
        controls.style.transform = "translateX(-50%)";
      }
      controls.style.display = "flex";
      controls.style.opacity = "1";
      controls.style.visibility = "visible";
    };

    fullscreenToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleFullscreen();
    });

    timeline.addEventListener("input", () => {
      isDragging = true;
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      if (duration > 0) {
        const ratio = Number(timeline.value) / 1000;
        video.currentTime = ratio * duration;
      }
    });

    timeline.addEventListener("change", () => {
      isDragging = false;
    });

    video.addEventListener("loadedmetadata", () => {
      updateTime();
      syncControlWidth();
    });
    video.addEventListener("loadeddata", syncControlWidth);
    video.addEventListener("timeupdate", updateTime);
    window.addEventListener("resize", syncControlWidth);
    const handleFullscreenChange = () => {
      updateFullscreenLayout();
      syncControlWidth();
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);
    updateTime();
    updateFullscreenLayout();
    syncControlWidth();

    controls.appendChild(timeline);
    controls.appendChild(timeLabel);
    controls.appendChild(fullscreenToggle);
    return controls;
  }

  formatMediaTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const total = Math.floor(seconds);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  changeDetailMedia(modal, container, delta) {
    if (
      !modal ||
      !Array.isArray(modal._mediaItems) ||
      !modal._mediaItems.length
    )
      return;
    const items = modal._mediaItems;
    const nextIndex = Math.min(
      Math.max(modal._mediaIndex + delta, 0),
      items.length - 1
    );
    if (nextIndex === modal._mediaIndex) return;
    this.renderDetailMedia(modal, container, nextIndex);
  }

  updateSummary(stats, reviews = []) {
    const hasStats = Boolean(
      stats && (stats.avg_rating != null || stats.review_count != null)
    );
    let avgRating = hasStats
      ? Number(stats.avg_rating || stats.average_rating || 0)
      : this.computeAverageFromReviews(reviews);
    let totalCount = hasStats
      ? Number(stats.review_count || stats.total_reviews || 0)
      : reviews.length;
    const breakdown = hasStats
      ? this.normalizeBreakdown(stats, totalCount)
      : this.computeBreakdownFromReviews(reviews);

    const avg = Number(avgRating || 0).toFixed(1);
    if (this.summaryNodes.avgRating)
      this.summaryNodes.avgRating.textContent = avg;
    if (this.summaryNodes.avgRatingMobile)
      this.summaryNodes.avgRatingMobile.textContent = avg;
    if (this.summaryNodes.totalText && hasStats) {
      const total = totalCount || 0;
      this.summaryNodes.totalText.textContent = `${total} verified reviews`;
    }
    if (this.summaryNodes.totalTextMobile && hasStats) {
      const total = totalCount || 0;
      this.summaryNodes.totalTextMobile.textContent = `${total} verified reviews`;
    }
    if (this.summaryNodes.starSummaryDesktop) {
      this.summaryNodes.starSummaryDesktop.innerHTML = this.renderStarIcons(
        avgRating || 0
      );
    }
    if (this.summaryNodes.starSummaryMobile) {
      this.summaryNodes.starSummaryMobile.innerHTML = this.renderStarIcons(
        avgRating || 0
      );
    }

    for (let star = 1; star <= 5; star++) {
      const pct = breakdown[`rating_${star}`]
        ? breakdown[`rating_${star}`] * 100
        : 0;
      const bar = this.sectionEl.querySelector(`[data-rating-bar="${star}"]`);
      const value = this.sectionEl.querySelector(
        `[data-rating-value="${star}"]`
      );
      if (bar) bar.style.width = `${pct.toFixed(0)}%`;
      if (value) value.textContent = `${pct.toFixed(0)}%`;
    }
  }

  computeAverageFromReviews(reviews) {
    if (!reviews || !reviews.length) return 0;
    const sum = reviews.reduce((acc, r) => acc + (Number(r.rating) || 0), 0);
    return sum / reviews.length;
  }

  computeBreakdownFromReviews(reviews) {
    const breakdown = {
      rating_1: 0,
      rating_2: 0,
      rating_3: 0,
      rating_4: 0,
      rating_5: 0,
    };
    if (!reviews || !reviews.length) return breakdown;
    const total = reviews.length;
    reviews.forEach((r) => {
      const rounded = Math.round(Number(r.rating) || 0);
      const key = `rating_${rounded}`;
      if (breakdown[key] != null) breakdown[key] += 1;
    });
    Object.keys(breakdown).forEach((key) => {
      breakdown[key] = total ? breakdown[key] / total : 0;
    });
    return breakdown;
  }

  normalizeBreakdown(stats = {}, totalCount = 0) {
    const values = [];
    for (let star = 1; star <= 5; star++) {
      const raw = Number(stats[`rating_${star}`] ?? 0) || 0;
      values.push(raw);
    }
    const sum = values.reduce((acc, val) => acc + val, 0);
    const total = Number(totalCount) || 0;
    const denominator = sum > 1 ? (total > 0 ? total : sum) : 1; // assume ratios if sum <= 1

    const normalized = {};
    for (let star = 1; star <= 5; star++) {
      const raw = values[star - 1];
      normalized[`rating_${star}`] = denominator
        ? Math.max(0, raw / denominator)
        : 0;
    }
    return normalized;
  }

  partitionReviewsByMedia(reviews) {
    const media = [];
    const text = [];
    (reviews || []).forEach((r) => {
      if (r && r.has_media) {
        media.push(r);
      } else {
        text.push(r);
      }
    });
    return { media, text };
  }

  toggleEmptyState(isEmpty) {
    this.emptyNodes.forEach((node) => (node.hidden = !isEmpty));
    this.emptyNodesMobile.forEach((node) => (node.hidden = !isEmpty));
  }

  showErrorState(message) {
    const setError = (container) => {
      if (!container) return;
      container.textContent = "";
      const div = document.createElement("div");
      div.className = "kaido-reviews__error";
      div.textContent = message;
      container.appendChild(div);
    };
    setError(this.reviewsGridDesktop);
    setError(this.reviewsGridMobile);
  }

  async submitForm(form) {
    if (!this.canSubmitReview()) {
      this.openLoginModal();
      return;
    }

    const formData = new FormData(form);
    const rating = Number(formData.get("rating"));
    const title = (formData.get("title") || "").trim();
    const body = (formData.get("body") || "").trim();
    const nickname =
      (formData.get("nickname") || "").trim() ||
      this.customerName ||
      "Anonymous";
    const selection = this.getProductSelectionForForm(form);
    const selectedProductId = selection.productId || this.productId;
    const selectedToken = selection.token || this.reviewToken;
    const statusNode = form.querySelector("[data-form-status]");
    if (!selectedProductId) {
      this.setFormStatus(
        statusNode,
        "Please select a product before continuing.",
        "error"
      );
      return;
    }
    if (!selectedToken) {
      this.setFormStatus(
        statusNode,
        "No review invite found for this product.",
        "error"
      );
      return;
    }

    if (!rating || !title || !body) {
      this.setFormStatus(
        statusNode,
        "Please complete all required fields.",
        "error"
      );
      return;
    }

    // Validate body length (must be between 20 and 5000 characters)
    if (body.length < 20) {
      this.setFormStatus(
        statusNode,
        "Review description must be at least 20 characters.",
        "error"
      );
      return;
    }

    if (body.length > 5000) {
      this.setFormStatus(
        statusNode,
        "Review description must be no more than 5000 characters.",
        "error"
      );
      return;
    }

    const unifiedInput = form.querySelector('[data-media-input="unified"]');
    const allFiles =
      unifiedInput && unifiedInput.files ? Array.from(unifiedInput.files) : [];

    // Separate files by type
    const photoFiles = allFiles
      .filter((file) => file.type.startsWith("image/"))
      .slice(0, KAIDO_REVIEWS_CONFIG.media.maxImages);
    const videoFiles = allFiles
      .filter((file) => file.type.startsWith("video/"))
      .slice(0, KAIDO_REVIEWS_CONFIG.media.maxVideos);

    // Validate file sizes before upload
    const MAX_IMAGE_SIZE = 25 * 1024 * 1024; // 25MB
    const MAX_VIDEO_SIZE = 250 * 1024 * 1024; // 250MB

    // Check video file sizes
    for (const file of videoFiles) {
      if (file.size > MAX_VIDEO_SIZE) {
        this.setFormStatus(
          statusNode,
          `Video file "${file.name}" is too large. Maximum size is 250MB.`,
          "error"
        );
        return;
      }
    }

    // Validate image sizes before processing
    for (const file of photoFiles) {
      if (file.size > MAX_IMAGE_SIZE) {
        this.setFormStatus(
          statusNode,
          `Image "${file.name}" is too large. Maximum size is 25MB.`,
          "error"
        );
        return;
      }
    }

    try {
      // Compress images for faster upload
      if (photoFiles.length > 0) {
        this.setFormStatus(statusNode, "Optimizing images...", "info");
      }
      const compressedPhotoFiles = [];
      for (const file of photoFiles) {
        // Compress for faster upload
        const compressed = await this.compressImage(
          file,
          REVIEW_IMAGE_OUTPUT_HARD_BYTES,
          0.82
        );
        compressedPhotoFiles.push(compressed);
      }

      this.setFormStatus(statusNode, "Uploading files...", "info");

      const allFiles = [...compressedPhotoFiles, ...videoFiles];
      console.log("Files to upload:", allFiles.map(f => ({ name: f.name, size: f.size, type: f.type })));

      const uploadResult = await this.handleMediaUploads(
        allFiles,
        selectedToken
      );
      const payload = {
        token: selectedToken,
        reviewId: uploadResult.reviewId || undefined,
        productId: selectedProductId || this.productId,
        rating,
        title,
        body,
        nickname,
        authorName: nickname,
        media: uploadResult.media,
      };

      const response = await fetch(
        KAIDO_REVIEWS_CONFIG.endpoints.submitReview,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Origin: window.location.origin,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.error || "Unable to submit review.");

      // Bug 3 fix: the backend returns { deduped: true } with HTTP 200 when
      // a review for this token already exists. Treat this as a soft rejection
      // rather than a fresh success so the user is not misled.
      if (result.deduped) {
        this.setFormStatus(
          statusNode,
          "You've already submitted a review with this link. Only one review per invite is allowed.",
          "error"
        );
        return;
      }

      this.setFormStatus(
        statusNode,
        "Thanks! Your review has been submitted.",
        "success"
      );
      setTimeout(() => {
        const parentModal =
          typeof form.closest === "function"
            ? form.closest("[data-review-modal]")
            : null;
        if (parentModal) parentModal.classList.remove("is-open");
        form.reset();

        // Hide file preview on reset and clear accumulated files
        const formType = form.getAttribute("data-review-form-type");
        const formId = form.id || formType;
        const filePreview = form.querySelector(
          `[data-file-preview-${formType}]`
        );
        if (filePreview) {
          filePreview.hidden = true;
        }

        // Clear accumulated files for this form
        this.accumulatedFiles.delete(formId);

        this.fetchAndRenderReviews();
      }, 1200);
    } catch (error) {
      console.error("[Kaido Reviews] submit error", error);
      this.setFormStatus(
        statusNode,
        error.message || "Something went wrong. Please try again.",
        "error"
      );
    }
  }

  async handleMediaUploads(files, token) {
    if (!files.length) {
      return { media: [], reviewId: null };
    }

    if (!token) {
      throw new Error("Missing review invite. Please select a product again.");
    }

    let reviewId = null;
    const uploadedMedia = [];
    let videoIndex = 0;

    for (const file of files) {
      let extension = (file.name.split(".").pop() || "").toLowerCase();

      // If file was compressed to JPEG, use .jpg extension regardless of original
      if (file.type === "image/jpeg" && !extension.match(/^jpe?g$/)) {
        extension = "jpg";
      }

      const presignPayload = {
        token,
        mimeType: file.type,
        fileExtension: extension,
        fileSize: file.size,
      };
      if (reviewId) presignPayload.existingReviewId = reviewId;


      const presignRes = await fetch(
        KAIDO_REVIEWS_CONFIG.endpoints.presignUpload,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(presignPayload),
        }
      );
      const presignData = await presignRes.json();
      if (!presignRes.ok) {
        console.error("Presign error:", presignData);
        throw new Error(presignData.error || "Unable to prepare upload.");
      }

      reviewId = presignData.reviewId;
      const uploadResponse = await fetch(presignData.uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      });

      if (!uploadResponse.ok) throw new Error("Upload failed. Please retry the same file upload or contact support.");

      const mediaItem = {
        storage_path: presignData.objectPath,
        media_type: file.type.startsWith("video") ? "video" : "image",
      };

      // Derivatives are generated only by a trusted server pipeline.

      uploadedMedia.push(mediaItem);
    }

    return { media: uploadedMedia, reviewId };
  }

  async uploadVideoThumbnail(file, token, reviewId) {
    const blob = await this.createVideoThumbnail(file);
    if (!blob || !reviewId) return null;
    const presignPayload = {
      token,
      mimeType: blob.type || "image/jpeg",
      fileExtension: "jpg",
      fileSize: blob.size,
      existingReviewId: reviewId,
    };

    const presignRes = await fetch(
      KAIDO_REVIEWS_CONFIG.endpoints.presignUpload,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(presignPayload),
      }
    );
    const presignData = await presignRes.json();
    if (!presignRes.ok) {
      console.warn(
        "[Kaido Reviews] thumbnail presign failed",
        presignData?.error || presignRes.status
      );
      return null;
    }

    await fetch(presignData.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": blob.type || "image/jpeg" },
      body: blob,
    });

    return presignData.objectPath || null;
  }

  createVideoThumbnail(file, maxSize = 400) {
    if (!file || !file.type || !file.type.startsWith("video")) {
      return Promise.resolve(null);
    }

    return new Promise((resolve) => {
      const video = document.createElement("video");
      const objectUrl = URL.createObjectURL(file);
      let settled = false;

      const finalize = (blob) => {
        if (settled) return;
        settled = true;
        URL.revokeObjectURL(objectUrl);
        resolve(blob || null);
      };

      const captureFrame = () => {
        if (!video.videoWidth || !video.videoHeight) {
          finalize(null);
          return;
        }
        const scale = Math.min(
          maxSize / video.videoWidth,
          maxSize / video.videoHeight,
          1
        );
        const width = Math.max(1, Math.round(video.videoWidth * scale));
        const height = Math.max(1, Math.round(video.videoHeight * scale));
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          finalize(null);
          return;
        }
        ctx.drawImage(video, 0, 0, width, height);
        canvas.toBlob((blob) => finalize(blob), "image/jpeg", 0.82);
      };

      let seekTarget = 0;
      video.addEventListener(
        "loadedmetadata",
        () => {
          if (Number.isFinite(video.duration) && video.duration > 0) {
            seekTarget = Math.min(0.2, video.duration * 0.1);
            if (seekTarget > 0) {
              try {
                video.currentTime = seekTarget;
              } catch (error) {
                console.warn("[Kaido Reviews] thumbnail seek failed", error);
                seekTarget = 0;
              }
            }
          }
        },
        { once: true }
      );

      video.addEventListener(
        "loadeddata",
        () => {
          if (seekTarget === 0) {
            captureFrame();
          }
        },
        { once: true }
      );

      video.addEventListener(
        "seeked",
        () => {
          if (seekTarget > 0) {
            captureFrame();
          }
        },
        { once: true }
      );

      video.addEventListener("error", () => finalize(null), { once: true });

      video.muted = true;
      video.playsInline = true;
      video.preload = "metadata";
      video.src = objectUrl;
    });
  }

  renderFileList(fileListEl, files, formId, fileInput, reviewTypeSelect) {
    // console.log [DEBUG] (removed) renderFileList called with", files.length, "files");
    // console.log [DEBUG] (removed) fileListEl:", fileListEl);

    // Clear existing list
    fileListEl.innerHTML = "";

    // Create item for each file
    files.forEach((file, index) => {
      // console.log [DEBUG] (removed) Creating item for file:", file.name);
      const item = document.createElement("div");
      item.className = "kaido-file-item";
      item.dataset.fileName = file.name;

      const fileName = document.createElement("span");
      fileName.className = "kaido-file-name";
      fileName.textContent = `• ${file.name}`;
      fileName.title = file.name; // Tooltip for long names

      const deleteBtn = document.createElement("button");
      deleteBtn.className = "kaido-file-delete";
      deleteBtn.type = "button";
      deleteBtn.innerHTML = "x";
      deleteBtn.title = "Remove file";
      deleteBtn.setAttribute("aria-label", `Remove ${file.name}`);

      // Add click handler for deletion
      deleteBtn.addEventListener("click", async () => {
        await this.deleteFile(formId, file.name, fileInput, reviewTypeSelect);
      });

      item.appendChild(fileName);
      item.appendChild(deleteBtn);
      fileListEl.appendChild(item);
      // console.log [DEBUG] (removed) Appended item to fileListEl");
    });
  }

  async deleteFile(formId, fileName, fileInput, reviewTypeSelect) {

    // Get current accumulated files
    const currentFiles = this.accumulatedFiles.get(formId) || [];

    // Remove the file by name
    const updatedFiles = currentFiles.filter((f) => f.name !== fileName);

    // Update accumulated files
    this.accumulatedFiles.set(formId, updatedFiles);

    // Update the file input using DataTransfer
    try {
      const dt = new DataTransfer();
      updatedFiles.forEach((file) => dt.items.add(file));
      fileInput.files = dt.files;
    } catch (err) {
      console.warn("Could not update file input after deletion");
    }

    // Get form elements
    const form = fileInput.closest("form");
    if (!form) return;

    const formType = form.getAttribute("data-review-form-type");
    const filePreview = form.querySelector(`[data-file-preview-${formType}]`);
    const fileListEl = filePreview
      ? filePreview.querySelector("[data-file-list]")
      : null;
    const fileError = form.querySelector(`[data-file-error-${formType}]`);
    const errorMessageEl = fileError
      ? fileError.querySelector("[data-error-message]")
      : null;

    // Hide error
    if (fileError) {
      fileError.hidden = true;
    }

    // If no files left, hide preview
    if (updatedFiles.length === 0) {
      if (filePreview) {
        filePreview.hidden = true;
      }
      reviewTypeSelect.value = "text";
      return;
    }

    // Re-validate remaining files
    const validation = await this.validateFileUpload(updatedFiles);

    if (!validation.valid) {
      // Show error if remaining files are invalid
      if (fileError && errorMessageEl) {
        errorMessageEl.textContent = validation.error;
        fileError.hidden = false;

        // Auto-hide after 5 seconds
        setTimeout(() => {
          if (fileError) {
            fileError.hidden = true;
          }
        }, 5000);
      }
      // Clear all files on error
      this.accumulatedFiles.delete(formId);
      try {
        fileInput.value = "";
      } catch (err) {
        // Ignore
      }
      if (filePreview) {
        filePreview.hidden = true;
      }
      reviewTypeSelect.value = "text";
      return;
    }

    // Update review type
    const hasVideo = updatedFiles.some((file) =>
      file.type.startsWith("video/")
    );
    const hasImage = updatedFiles.some((file) =>
      file.type.startsWith("image/")
    );

    if (hasVideo) {
      reviewTypeSelect.value = "video";
    } else if (hasImage) {
      reviewTypeSelect.value = "photos";
    } else {
      reviewTypeSelect.value = "text";
    }

    // Re-render the file list
    if (fileListEl) {
      this.renderFileList(
        fileListEl,
        updatedFiles,
        formId,
        fileInput,
        reviewTypeSelect
      );
    }
  }

  async validateFileUpload(files) {
    const MAX_IMAGE_SIZE = 25 * 1024 * 1024; // 25MB
    const MAX_VIDEO_SIZE = 250 * 1024 * 1024; // 250MB (no compression)
    const MAX_IMAGES = 2;
    const MAX_VIDEOS = 1;

    if (!files || files.length === 0) {
      return { valid: true };
    }

    const imageFiles = files.filter((f) => f.type.startsWith("image/"));
    const videoFiles = files.filter((f) => f.type.startsWith("video/"));
    const otherFiles = files.filter(
      (f) => !f.type.startsWith("image/") && !f.type.startsWith("video/")
    );

    // Check for unknown file types
    if (otherFiles.length > 0) {
      return { valid: false, error: "Only image and video files are allowed" };
    }

    // Can't mix photos and videos
    if (imageFiles.length > 0 && videoFiles.length > 0) {
      return {
        valid: false,
        error: "You can upload photos OR video, but not both",
      };
    }

    // Check image count
    if (imageFiles.length > MAX_IMAGES) {
      return { valid: false, error: `Maximum ${MAX_IMAGES} images allowed` };
    }

    // Check video count
    if (videoFiles.length > MAX_VIDEOS) {
      return { valid: false, error: `Maximum ${MAX_VIDEOS} video allowed` };
    }

    // Validate video sizes
    for (const video of videoFiles) {
      if (video.size > MAX_VIDEO_SIZE) {
        return {
          valid: false,
          error: `Video "${video.name}" is too large. Maximum size is 250MB`,
        };
      }
    }

    // Validate image sizes - check original size first
    for (const image of imageFiles) {
      if (image.size > MAX_IMAGE_SIZE) {
        return {
          valid: false,
          error: `Image "${image.name}" is too large. Maximum size is 25MB`,
        };
      }
    }

    return { valid: true };
  }

  async compressImage(
    file,
    maxSizeBytes = REVIEW_IMAGE_OUTPUT_HARD_BYTES,
    initialQuality = 0.82
  ) {
    if (!file.type.startsWith("image/")) return file;

    const startedAt = performance.now();
    const assertWithinDeadline = () => {
      if (
        performance.now() - startedAt >
        REVIEW_IMAGE_COMPRESSION_TIMEOUT_MS
      ) {
        throw new Error(
          "Image optimization took too long. Please try a smaller image."
        );
      }
    };

    const image = await new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      const timeoutId = window.setTimeout(() => {
        img.src = "";
        URL.revokeObjectURL(objectUrl);
        reject(
          new Error(
            "Image optimization took too long. Please try a smaller image."
          )
        );
      }, REVIEW_IMAGE_COMPRESSION_TIMEOUT_MS);

      const cleanup = () => {
        window.clearTimeout(timeoutId);
        URL.revokeObjectURL(objectUrl);
      };

      img.onload = () => {
        cleanup();
        resolve(img);
      };
      img.onerror = () => {
        cleanup();
        reject(new Error("This image could not be opened."));
      };
      img.src = objectUrl;
    });

    const sourceWidth = image.naturalWidth || image.width;
    const sourceHeight = image.naturalHeight || image.height;
    if (!sourceWidth || !sourceHeight) {
      throw new Error("This image has invalid dimensions.");
    }

    const hardMaxBytes = Math.max(1, Number(maxSizeBytes) || 1);
    const softTargetBytes = Math.min(
      REVIEW_IMAGE_OUTPUT_SOFT_BYTES,
      hardMaxBytes
    );
    const qualityCeiling = Math.min(0.92, Math.max(
      REVIEW_IMAGE_QUALITY_FLOOR,
      Number(initialQuality) || 0.82
    ));
    const dimensions = [...new Set(
      REVIEW_IMAGE_DIMENSION_STEPS.map((step) =>
        Math.min(step, Math.max(sourceWidth, sourceHeight))
      )
    )];

    const encodeCanvas = (canvas, quality) =>
      new Promise((resolve, reject) => {
        assertWithinDeadline();
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image optimization failed."));
              return;
            }
            resolve(blob);
          },
          "image/jpeg",
          quality
        );
      });

    let finalBlob = null;
    for (const longestEdge of dimensions) {
      assertWithinDeadline();
      const scale = Math.min(
        1,
        longestEdge / Math.max(sourceWidth, sourceHeight)
      );
      const width = Math.max(1, Math.round(sourceWidth * scale));
      const height = Math.max(1, Math.round(sourceHeight * scale));
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d", { alpha: false });
      if (!ctx) throw new Error("Image optimization is unavailable.");

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(image, 0, 0, width, height);

      const firstBlob = await encodeCanvas(canvas, qualityCeiling);
      if (firstBlob.size <= softTargetBytes) {
        finalBlob = firstBlob;
        break;
      }

      let low = REVIEW_IMAGE_QUALITY_FLOOR;
      let high = qualityCeiling;
      let bestBlob = null;
      for (let attempt = 0; attempt < 7; attempt += 1) {
        assertWithinDeadline();
        const quality = (low + high) / 2;
        const candidate = await encodeCanvas(canvas, quality);
        if (candidate.size <= softTargetBytes) {
          bestBlob = candidate;
          low = quality;
        } else {
          high = quality;
        }
      }

      if (bestBlob) {
        finalBlob = bestBlob;
        break;
      }

      const floorBlob = await encodeCanvas(
        canvas,
        REVIEW_IMAGE_QUALITY_FLOOR
      );
      if (floorBlob.size <= hardMaxBytes) {
        finalBlob = floorBlob;
        break;
      }
    }

    if (!finalBlob || finalBlob.size > hardMaxBytes) {
      throw new Error(
        "This image could not be reduced below 1 MB. Please choose a smaller image."
      );
    }

    return new File([finalBlob], file.name, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
  }

  setFormStatus(node, message, type) {
    if (!node) return;
    node.textContent = message;
    node.classList.remove("is-error", "is-success", "is-info");
    if (type === "error") node.classList.add("is-error");
    if (type === "success") node.classList.add("is-success");
    if (type === "info") node.classList.add("is-info");
  }
}

/* ============================================================
   v2.4.2 polish — selectable reward pills (Fix B)
   ============================================================
   Makes the three <li> pills in .kaido-review-entry-rewards__list
   clickable. Clicking one applies .is-selected and removes it
   from its siblings. Photo (index 1) is selected by default on
   init. PURELY VISUAL — does not touch form state, review_type,
   or submit payload. Also promotes pills to button semantics
   (role=button, tabindex=0) and wires Space/Enter.
   ============================================================ */
(function () {
  function wirePills(list) {
    if (!list || list.dataset.v242Wired === "1") return;
    list.dataset.v242Wired = "1";
    var pills = list.querySelectorAll("li");
    if (!pills.length) return;
    pills.forEach(function (pill, idx) {
      pill.setAttribute("role", "button");
      pill.setAttribute("tabindex", "0");
      // Default: Photo (index 1) is selected
      if (idx === 1) pill.classList.add("is-selected");
      var select = function () {
        pills.forEach(function (p) { p.classList.remove("is-selected"); });
        pill.classList.add("is-selected");
      };
      pill.addEventListener("click", select);
      pill.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          select();
        }
      });
    });
  }
  function initAll() {
    document
      .querySelectorAll(".kaido-review-entry-rewards__list")
      .forEach(wirePills);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

